<template>
  <div :style="{ zoom: zoomRatio }">
    <div :style="dateDivStyle">
      {{ value.date | formatTime('MM/DD') }} {{ value.date | readableWeek }}
      <span v-show="isFirst" :style="unitSpanStyle">
        {{ unit }}
      </span>
    </div>
    <!-- <div :id="`pumpDailyGraph_event_${id}`" :style="{ width: w + 'px', height: (0.1 * h) + 'px'}"></div> -->
    <!-- <div :id="`pumpDailyGraph_${id}`" :style="{ width: w + 'px', height: (0.8 * h - dateDivH) + 'px'}"> -->
    <div :id="`pumpDailyGraph_${id}`" :style="{ width: w + 'px', height: (0.9 * h - dateDivH) + 'px'}">
    </div>
    <div :id="`pumpDailyGraph_co_${id}`" :style="{ width: w + 'px', height: (0.1 * h) + 'px'}">
    </div>
    <div :id="`pumpDailyGraph_bar_${id}`" :style="{ width: w + 'px', height: (0.9 * h + 1.05 * lfs) + 'px'}">
    </div>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import { qcopy, isHighGlu, isLowGlu, isNormalGlu, findObjIndexInArray, padZero, trimEndZero } from '@u'
import dayjs from 'dayjs'
import { getSymbol } from './getSymbol'
import { pumpGetSymbol } from './pumpGetSymbol'
import { readableWeek } from '@/filters'
import { getLocaleDateFormat } from '@/util/dateFormat'
import { derrorFactory, errorFactory, dlogFactory } from '@u/log'
// import $ from 'jquery'
import { _getPumpBasalFromRecords, _appendTwoPointsToBasals, _getPumpBasalShouldShowLabelRecordsFromBasals, _getPumpBigDosageFromRecords, _getMergedPumpBigDosageFromRecords, SVG, _sortCgmRecordListByTimeAsc, getBigDosageData, getBigDosageType, universalFontFamily, canvasRatio } from '@u/reportHelper'
import { _transferBasalData, _transferBigDosageBarData, _heightEquilToBigDosageV, _createLineAreaWithDiffentColor, labelSize, _otherDataGetTempBasalFilter, _otherDataGetTempBasalStopFilter, _otherDataGetReservoirChangeFilter, _otherDataGetModuleChangeFilter, _otherDataGetPumpClockFilter, _otherDataGetTimeZoneFilter, _isTempBasalVersion2, _getTempBasalDurationVersion2, _isTempBasalVersion2Percent, _getTempBasalVersion2Percent, _getDeadlineGaps, _tempBasalDuration, _evenEventIcons, _evenVerticalDashLine } from '@u/reportHelperPump'
import { _transferBGData, _transferYHeightToBGValue } from '@u/reportHelperBGGreater20'
// import { _transferBGData, _transferYHeightToBGValue } from '@u/reportHelperBG'
import { _axisLabelColor, _axisLineColor } from '@u/reportUiVariables-pump'
import { _getUTCOffset } from '@u/timezoneDict'
import { _createVerticalDashLineWithBigDosage, _whatBasalsRange, _getType, _factoryRect, _factoryLabels, _drawRectsToCanvas, _getRectBarData, _getRichObj, _evenLabelData, _registerLogger, _isSplittedExtendDosageAndNotInDual, _isNotInDual } from './ChartDailyPumpHelper'
import Rect from './canvasRect.js'

const error = errorFactory('ChartDailyPump', true) // 第二个参数是disabled
const derror = derrorFactory('ChartDailyPump', true)
const log = dlogFactory('ChartDailyPump', true)
_registerLogger({ error, derror, log }) // ChartDailyPumpHelper里头的函数用

const labelCom = {
  fontFamily: universalFontFamily
}

const _cache = {
  barRects: [],
  labelRects: [],
  pack: [], // 大剂量标签被位移过
  unpack: [], // 大剂量标签放不下了，没地方位移
  zebraPack: [],
  zebraUnpack: [],
  zebraRects: [], // 临时基础率画出来的矩形
  zebraLabelRects: [] // 临时基础率的label的矩形
}
// window._cacheDaily = _cache

let _id = 1
const fmt = 'YYYY-MM-DD HH:mm:ss'
const nowT = dayjs()
const startOfDay = nowT.startOf('day')
const _eventDatasHeight = 10.1
export default {
  name: 'CCPumpDailyGraph',
  mixins: [reDrawTrigger],
  props: {
    allDeadlineGaps: {
      type: [Array],
      default: () => []
    },
    uploadEvents: { // 上传数据事件
      type: [Array],
      default: () => []
    },
    quickPumpTagList: { // 立即大剂量(用户通过泵体的快捷键打的大剂量)
      type: [Array],
      default: () => []
    },
    basalRateInfoMsg: {
      type: [Array],
      default: () => []
    },
    basalRateBaseSetting: {
      type: [Array],
      default: () => []
    },
    warnings: {
      type: [Array],
      default: () => []
    },
    value: {
      type: [Object],
      default: () => {}
    },
    yesterday: {
      type: [Object],
      default: () => {}
    }
  },
  data() {
    _id++
    const id = `cdailypump_${+new Date()}_${_id}`
    return {
      id,
      isFirst: true,
      isLast: false,
      bigDosageMinWidthMinutes: 15
    }
  },
  computed: {
    dateDivH() {
      const { lfs } = this
      return Math.round((5) * lfs)
    },
    dateDivStyle() {
      const { lfs, dateDivH, isFirst } = this
      const rst = { position: 'relative', color: 'black', 'height': dateDivH + 'px', 'lineHeight': dateDivH + 'px', fontSize: (18 / 12) * lfs + 'px', 'fontWeight': 'bold' }
      if (isFirst) {
        rst.textIndent = (28 / 12) * lfs + 'px'
      } else {
        rst.textIndent = (36 / 12) * lfs + 'px'
      }
      return rst
    },
    unitSpanStyle() {
      const { lfs } = this
      const rst = { position: 'absolute', top: (18 / 12) * lfs + 'px', left: (0 - lfs) + 'px' }
      Object.assign(rst, {
        color: _axisLabelColor,
        fontWeight: 'normal',
        fontSize: (16 / 12) * lfs
      })
      return rst
    },
    // eventLabelStyle() {
    //   const { dateDivH, lfs, lang } = this
      
    //   const rst = { position: 'absolute', top: (dateDivH / 2 + 0.2 * lfs) + 'px', left: (0 - 2.3 * lfs) + 'px' }
    //   Object.assign(rst, {
    //     color: _axisLabelColor,
    //     fontWeight: 800,
    //     fontSize: (16 / 12) * lfs,
    //     textAlign: 'left'
    //   })
      
    //   /* eslint-disable */
    //   switch(`${lang}`) {
    //   case 'sl': // 斯洛文尼亚
    //   case 'sk': // 斯洛伐克
    //   case 'hr': // 克罗地亚
    //   case `de`:
    //     Object.assign(rst, {
    //       // textIndent: `${0.4 * lfs}px`,
    //       top: `${(dateDivH / 2 + 0.3 * lfs)}px`
    //     })
    //     break
    //   }
    //   /* eslint-enable */
    //   return rst
    // },
    lastUploadTime() { // (整个报告期间，而不是今天的最后一次数据上传)最后一次数据上传(绘图截止到这个事件的时间点)
      const { uploadEvents = [] } = this
      if (uploadEvents && uploadEvents.length) {
        const sorted = (uploadEvents.slice().sort((a, b) => dayjs(b.uploadTimeStr) - dayjs(a.uploadTimeStr)))
        const obj = sorted[0]

        if (Number.isNaN(+obj.uploadTimeStr)) {
          return +dayjs(obj.uploadTimeStr)
        } else {
          return obj.uploadTimeStr
        }
      } else {
        return 0
      }
    },
    reservoirChanges() { // 换底板事件
      const { value } = this
      const { date, otherData = [] } = value
      const changeRecords = (otherData.filter(_otherDataGetReservoirChangeFilter)).sort((first, second) => dayjs(first.dateTimeStr) - dayjs(second.dateTimeStr)) // 升序, dateTimeStr小的在数组前面
      
      const changes = changeRecords.filter(v => dayjs(`${v.dateTimeStr}`).format('YYYY-MM-DD') === `${date}`)
      
      if (!changes.length) {
        return []
      }
      return changes
    },
    changeModules() {
      const { value } = this
      const { threeChartData = {}, date, otherData = [] } = value
      const changeRecords = (otherData.filter(_otherDataGetModuleChangeFilter)).sort((first, second) => dayjs(first.dateTimeStr) - dayjs(second.dateTimeStr)) // 升序, dateTimeStr小的在数组前面
      
      const changes = changeRecords.filter(v => dayjs(`${v.dateTimeStr}`).format('YYYY-MM-DD') === `${date}`)
      
      if (!changes.length) {
        return []
      }
      return changes
    },
    sortedBasalRateBaseSetting() {
      const { basalRateBaseSetting = [] } = this
      const rst = basalRateBaseSetting.slice()
      rst.sort((first, second) => first.settingIndex - second.settingIndex) // 升序, settingIndex小的在数组前面
      return rst
    },
    w() {
      const ds = this.ds
      return Math.round(ds * (1600 / 1740))
    },
    totalH() {
      const ds = this.ds
      const h = ds * (414 / 1240)
      return h
    },
    h() {
      const { totalH } = this
      const grid = this.getCommonGridOpt()
      let rest = totalH
      
      if (grid.bottom && !Number.isNaN(+grid.bottom)) {
        rest -= grid.bottom
      }
      
      if (grid.top && !Number.isNaN(+grid.top)) {
        rest -= grid.top
      }
      return rest / 2
    },
    bigDosage() {
      const { value, bigDosageMinWidthMinutes } = this
      const { threeChartData = {}} = value
      const { insulinChart = {}} = threeChartData
      const { list2: pumpRecord } = insulinChart
      
      console.error(`bigDosage- bigDosageMinWidthMinutes: ${bigDosageMinWidthMinutes}`)
      const rst = _getPumpBigDosageFromRecords(pumpRecord, bigDosageMinWidthMinutes)
      // return []
      // window.bb = rst // dev, tbc, mock
      return rst
    },
    bigDosageMerged() {
      // const { value } = this
      // const { threeChartData = {}} = value
      // const { insulinChart = {}} = threeChartData
      // const t{ list: pumpRecord } = insulinChart
      
      // const rst = _getMergedPumpBigDosageFromRecords(pumpRecord)
      const { bigDosage, bigDosageMinWidthMinutes } = this
      
      const rst = _getMergedPumpBigDosageFromRecords(bigDosage, bigDosageMinWidthMinutes)
      // window.bbm = rst // dev, tbc, mock
      return rst      
    },
    dualIndexes() {
      const { bigDosageMerged } = this
      const duals = bigDosageMerged.filter(r => `${_getType(r)}` === '2') // 过滤出双波大剂量
      const indexes = duals.reduce((rst, cur) => {
        const arr = cur['indexes'].split(',')
        rst.push(...arr)
        return rst
      }, [])
      return indexes
    }
  },
  beforeDestroy() {
    try {
      if (this._drawDiamondTimer) {
        clearTimeout(this._drawDiamondTimer)
        this._drawDiamondTimer = null
      }
    } catch (err) {
      error('被捕获:' + err)
    }
  },
  mounted() {
    this.render(false)
    // this.demo()
  },
  methods: {
    getBigDosageVerticalSplitLineSeries(bigDosageMerged, hasLabel = false) {
      return [
        {
          name: '大剂量-分割线',
          type: 'line',
          yAxisIndex: 0,
          // data: bigDosage,
          symbol: 'none',
          lineStyle: {
            width: 0
          },
          markLine: {
            silent: true,
            symbol: 'none',
            data: _createVerticalDashLineWithBigDosage(bigDosageMerged, this, hasLabel)
          }
        }
      ]
    },
    getEventDatas() { // 返回 换底板、告警(alarm)、上传记录, 因为这些图标可能会挤压在一起
      const { value, lfs, reservoirChanges = [], warnings = [], uploadEvents = [] } = this
      const { threeChartData = {}, date } = value
      
      const rst = []
      
      // 换底板
      rst.push(...reservoirChanges.map(v => {
        return [
          +dayjs(v.dateTimeStr),
          _eventDatasHeight,
          'reservoir'
        ]
      }))
      
      // 告警
      const warns = warnings.filter(v => `${v.date}` === `${date}`)
      if (warns.length) {
        const list = warns[0] ? warns[0].list : []
        rst.push(...list.map(v => {        
          return [
            +dayjs(v.dateTimeStr),
            _eventDatasHeight,
            'alarm'
          ]
        }))
      }
      
      // 上传记录
      const uploads = uploadEvents.filter(obj => { // 过滤出今天的upload事件的series
        const fmt = 'YYYY-MM-DD'
        const sameDay = dayjs(date).format(fmt) === dayjs(obj.uploadTimeStr).format(fmt)
        const equilsWifi = String(obj?.sourceType) === '2'
        return sameDay && !equilsWifi
      })
      rst.push(...uploads.map(v => {
        return [
          +dayjs(v.uploadTimeStr),
          _eventDatasHeight,
          'upload'
        ]
      }))
      
      // 先排序
      rst.sort((first, second) => dayjs(first[0]) - dayjs(second[0]))
      
      _evenEventIcons(rst, +dayjs(date))
      return rst
    },
    getReservoirChangeSeries() {
      const events = this.getEventDatas()
      const _eventDatas = events.filter(arr => arr[2] === 'reservoir')
      
      const rst = {
        name: 'reservoirAlarms',
        type: 'line',
        showBackground: true,
        lineStyle: {
          width: 0
        },
        showSymbol: true,
        symbol: (value, params) => {
          const eventType = value[2]
          const symbol = pumpGetSymbol(eventType)
          return symbol
        },
        symbolSize: 20,
        smooth: true,
        data: _eventDatas
      }
      return [rst]
    },
    getPumpAlarmSeries() {
      const events = this.getEventDatas()
      const _eventDatas = events.filter(arr => arr[2] === 'alarm')
      
      const rst = {
        name: 'pumpAlarms',
        type: 'line',
        showBackground: true,
        lineStyle: {
          width: 0
        },
        showSymbol: true,
        symbol: (value, params) => {
          const eventType = value[2]
          const symbol = pumpGetSymbol(eventType)
          return symbol
        },
        symbolSize: 20,
        smooth: true,
        data: _eventDatas
      }
      return [rst]
    },
    getPumpClockSeries() {
      const { value, lfs } = this
      const { threeChartData = {}, date, otherData = [] } = value
      const changeTimes = otherData.filter(_otherDataGetPumpClockFilter).sort((first, second) => dayjs(first.dateTimeStr) - dayjs(second.dateTimeStr))
      
      const clocks = (changeTimes.filter(v => dayjs(`${v.dateTimeStr}`).format('YYYY-MM-DD') === `${date}`)).map(obj => {
        const isTimeZoneChangeRecord = _otherDataGetTimeZoneFilter(obj)
        const rst = {
          ...qcopy(obj)
        }
        rst['isTimeZoneChangeRecord'] = isTimeZoneChangeRecord
        return rst
      })
      
      if (!clocks.length) {
        return []
      }
      
      const _eventDatas = clocks.map(v => {
        const { eventType, isTimeZoneChangeRecord } = v
        if (isTimeZoneChangeRecord) {
          // 改时区
          const beforeTZIndex = v.statusByte1
          const afterTZIndex = v.statusByte0
          const beforeTZOffset = _getUTCOffset(beforeTZIndex)
          const afterTZOffset = _getUTCOffset(afterTZIndex)
          derror(`beforeTZOffset: ${beforeTZOffset}, afterTZOffset: ${afterTZOffset}`)
          const before = `${this.$t('UTC')}${beforeTZOffset >= 0 ? '+' : ''}${beforeTZOffset}`
          const after = `${this.$t('UTC')}${afterTZOffset >= 0 ? '+' : ''}${afterTZOffset}`
          const t = dayjs(v.dateTimeStr)
          
          const extra = `${before}->${after}`
          return [
            +t,
            _eventDatasHeight,
            'clock',
            extra
          ]
        } else {
          // 改时间
          const beforeHour = v.statusByte1
          const beforeMinute = v.statusByte0
          const beforeMD = `${v.statusShort0}`
          const beforeDay = beforeMD.substr(-2)
          const beforeMonth = beforeMD.substr(0, beforeMD.length - 2)
          let before
          if (this.$i18n.locale === 'ru') {
            before = `${padZero(beforeDay)}.${padZero(beforeMonth)} ${padZero(beforeHour)}:${padZero(beforeMinute)}`
          } else {
            before = `${padZero(beforeMonth)}/${padZero(beforeDay)} ${padZero(beforeHour)}:${padZero(beforeMinute)}`
          }
          // const after = dayjs(v.dateTimeStr).format('HH:mm')
          const after = dayjs(v.dateTime).format(`${getLocaleDateFormat('MM/DD')} HH:mm`)
          
          const extra = `${before}->${after}`
          return [
            +dayjs(v.dateTimeStr),
            _eventDatasHeight,
            'clock',
            extra
          ] 
        }
      })
      
      const rst = {
        name: 'pumpClocks',
        type: 'line',
        showBackground: true,
        lineStyle: {
          width: 0
        },
        label: {
          show: true,
          position: 'right',
          distance: 3,
          formatter: (params) => {
            const { data = [] } = params
            const l = data[3] || ''
            return l
          }
        },
        showSymbol: true,
        symbol: (value, params) => {
          const eventType = value[2]
          const symbol = pumpGetSymbol(eventType)
          return symbol
        },
        symbolSize: 20,
        smooth: true,
        data: _eventDatas
      }
      return [rst]
    },
    getPumpUploadSeries() {
      const events = this.getEventDatas()
      const _eventDatas = events.filter(arr => arr[2] === 'upload')
      
      const rst = {
        name: 'pumpUploads',
        type: 'line',
        showBackground: true,
        lineStyle: {
          width: 0
        },
        label: {
          show: true,
          position: 'right',
          distance: 3,
          formatter: (params) => {
            const { data = [] } = params
            const l = data[3] || ''
            return l
          }
        },
        showSymbol: true,
        symbol: (value, params) => {
          const eventType = value[2]
          const symbol = pumpGetSymbol(eventType)
          return symbol
        },
        symbolSize: 20,
        smooth: true,
        data: _eventDatas
      }
      return [rst]
    },
    getBasalChangeSeries() {
      const { lfs } = this
      const { changeModules: changes } = this
      const _eventDatas = changes ? changes.map((v, i) => {
        derror(`basal changes`, { v, i })
        return [
          +dayjs(v.dateTimeStr),
          2.5,
          i + 1 // 第几次切换
        ]
      }) : []
      
      const rst = {
        name: 'pumpChangeModules',
        type: 'line',
        yAxisIndex: 0,
        showSymbol: true,
        symboleKeepAspect: true,
        symbolSize: 20,
        symbolOffset: [0, '-50%'],
        // symbolOffset: [0, 0],
        label: {
          show: true,
          position: 'top',
          color: 'black',
          offset: [0, lfs * 1.5],
          formatter: (params) => {
            const { data } = params
            const what = data[2]
            return what
          }
        },
        markLine: {
          // symbol: 'none',
          symbolSize: 0,
          silent: true,
          lineStyle: {
            // color: '#333',
            color: 'black', // #333: rgb(51, 51, 51)
            type: 'solid',
            width: '1'
          },
          data: _eventDatas.map(arr => {
            const [x, y] = arr
            return [
              {
                coord: [x, 0]
              },
              {
                coord: [x, y]
              }
            ]
          })
        },
        symbol: pumpGetSymbol('changeModule'),
        lineStyle: {
          width: 0
        },
        data: _eventDatas
      }
      return [rst]
    },
    getDeadlineGaps(date) {
      const { allDeadlineGaps } = this
      
      if (date) {
        const ddate = dayjs(date)
        const st = +ddate
        const et = (+ddate.add(1, 'day')) - 1
        
        const rst = []
        
        allDeadlineGaps.forEach(gap => {
          const [t0, t1] = gap
          const notInDate = (t1 - st < 0) || (t0 - et > 0)
          if (!notInDate) { // 在date时间范围内
            const start = Math.max(t0, st)
            const end = Math.min(t1, et)
            rst.push([start, end])
          }
        })
        
        derror(`getDeadlineGaps, allDeadlineGaps.length: ${allDeadlineGaps.length}, date: ${date} , rst `, rst.map(gap => [dayjs(gap[0]).format('MM/DD HH:mm'), dayjs(gap[1]).format('MM/DD HH:mm')]))
        return rst
      } else {
        derror(`getDeadlineGaps返回所有的, allDeadlineGaps.length: ${allDeadlineGaps.length}`)
        return allDeadlineGaps
      }
    },
    getBigDosageSeries() { // 获取大剂量的矩形图
      const { lfw, lfs, bigDosage, bigDosageMerged, bigDosageMinWidthMinutes, bigDosageTypeColorsLinear, bigDosageTypeColors } = this
      
      const dualIndexes = this.dualIndexes || []
      
      derror(`_getBigDosageSeries dualIndexes: `, {
        dualIndexes,
        bigDosageMerged,
        bigDosage
      })
      
      const rst = []
      const _types = ['2', '1', '0']
      // const _types = ['1']
      _cache[`barRects`] = []
      rst.push(..._types.map(t => {
        let data = []
        if (`${t}` !== '2') {
          // 不是双波
          data = bigDosage.filter(r => `${_getType(r)}` === t && !dualIndexes.includes(`${r['index']}`)) // 根据t过滤
        } else {
          // 获取双波的records的data
          data = bigDosage.filter(r => {
            const i = r['index']
            
            if (i === undefined) {
              derror(`[致命错误]过滤大剂量数据时候，发现没有index字段，这不允许，因为这样的话，我们就无法判断是否是双波`)              
            }
            return dualIndexes.includes(`${i}`)
          }) // 根据t过滤
          derror(`_factory 获取双波 `, {
            dualIndexes,
            bigDosage,
            data
          })
        }
        
        const frst = _factoryRect(data, t, { onlyRect: true, bigDosageMinWidthMinutes, bigDosageTypeColorsLinear, bigDosageTypeColors, lfs })
        const { opt, rectData } = frst        
        _cache[`rect${t}Data`] = rectData // dev, test
        _cache[`rect${t}`] = frst.rects // dev, test
        _cache[`barRects`].push(...frst.rects)
        return opt
      }))
      derror(`getBigDosageSeries, rst: `, rst)
      return rst      
    },
    getBigDosageLabels() { // 画大剂量的label
      const { value, lfw, lfs, bigDosage, bigDosageMerged, bigDosageMinWidthMinutes, bigDosageTypeColorsLinear, bigDosageTypeColors } = this
      const { date } = value
      
      const dualIndexes = this.dualIndexes || []
      derror(`getBigDosageLabels dualIndexes: `, {
        dualIndexes,
        bigDosageMerged,
        bigDosage
      })
      
      const rst = []
      const _types = ['2', '1', '0']
      // const _types = ['1']
      const labelsData = []
      
      // reset cache
      /* eslint-disable */
      ;[`labelRects`, 'pack', 'unpack', 'zebraRects', 'zebraLabelRects', 'zebraPack', 'zebraUnpack'].forEach(k => { // 行首一定要加;
        _cache[k] = []
      })
      /* eslint-enable */
      
      _types.forEach(t => {
        let data = []
        if (`${t}` !== '2') {
          // 不是双波
          data = bigDosage.filter(r => `${_getType(r)}` === t && !dualIndexes.includes(`${r['index']}`)) // 根据t过滤
        } else {
          // 获取双波的records的data
          data = bigDosage.filter(r => {
            const i = r['index']
            
            if (i === undefined) {
              derror(`[致命错误]过滤大剂量数据时候，发现没有index字段，这不允许，因为这样的话，我们就无法判断是否是双波`)              
            }
            return dualIndexes.includes(`${i}`)
          }) // 根据t过滤
          derror(`_factory 获取双波(labels) `, {
            dualIndexes,
            bigDosage,
            data
          })
        }
        
        const dataWithoutSplittedExtend = data.filter(r => !_isSplittedExtendDosageAndNotInDual(r) && _isNotInDual(r)) // 不是双波大剂量的大剂量(不包含分割的延长量)
        // const dataWithoutSplittedExtend = data.filter(r => !_isSplittedExtendDosageAndNotInDual(r))
        labelsData.push(...dataWithoutSplittedExtend)
      })
      
      // 再加上双波大剂量(但不含双波大剂量里头被分割的延长量)
      const d3 = bigDosageMerged.filter(r => !_isNotInDual(r)) // 同一个groupId(即同一个双波，已经在bigDosageMerged里头合并成一个记录)
      labelsData.push(...d3)
      
      // 再增加"被分割成多份record的延长大剂量的label"
      const d2 = bigDosageMerged.filter(r => _isSplittedExtendDosageAndNotInDual(r))
      labelsData.push(...d2)
      
      const frst = _factoryLabels(labelsData, { onlyLabel: true, bigDosageMinWidthMinutes, bigDosageTypeColorsLinear, bigDosageTypeColors, lfs })
      const { opt, rectData } = frst
      _cache[`rectDataLabel`] = rectData // dev, test
      _cache[`rectLabel`] = frst.rects // dev, test
      _cache[`labelRects`].push(...frst.rects)
      
      // 排序
      const _bars = _cache['barRects'] // 大剂量的矩形柱子
      const _labelRects = _cache['labelRects']
      const _labelRectsNoDurationLabels = _labelRects.filter(r => !(r && r['td']))
      const _labelRectsHasDurationLabels = _labelRects.filter(r => r && r['td'])
      const _labelRectsHasDurationLabelsSorted = _labelRectsHasDurationLabels.sort((rA, rB) => {
        const oA = Rect.findMaxOverlapRectangleAndArea(rA, _bars)
        const oB = Rect.findMaxOverlapRectangleAndArea(rB, _bars)
        return oB.area - oA.area // Rect.findMaxOverlapRectangle越大的越前面,即: 能绘画空间最小的越前面
      })
      
      _cache['labelRectsSorted'] = [..._labelRectsNoDurationLabels, ..._labelRectsHasDurationLabelsSorted]
      // _cache['labelRectsSorted'] = [..._labelRectsNoDurationLabels] // test dev
      const _sortedRects = _cache['labelRectsSorted']
      const $s = dayjs(date)
      const stime = +($s.startOf('day'))
      const etime = +($s.endOf('day'))
      // const _tmp1 = Rect.packRectangles((_sortedRects.filter(rect => +rect.type === 1)), (etime - stime), 10, _cache['barRects'])
      const _tmp1 = Rect.packRectangles(_sortedRects, (etime - stime), 10, _cache['barRects'])
      _cache['pack'] = _tmp1['pack']
      _cache['unpack'] = _tmp1['unpack']
      
      if (_tmp1['unpack'] && _tmp1['unpack'].length) {
        console.error(`警告，有${_tmp1['unpack'].length}标签放不下到canvas里头`, _tmp1['unpack'])
      }
      const { opt: packedOpt } = _drawRectsToCanvas([..._tmp1['unpack'], ..._tmp1['pack']], { bigDosageMinWidthMinutes, bigDosageTypeColorsLinear, bigDosageTypeColors, lfs })
      
      // if (_tmp1['unpack'] && _tmp1['unpack'].length) {
      //   console.error(`警告，记得unpack放回去.目前unpack不绘制`)        
      // }
      // const { opt: packedOpt } = _drawRectsToCanvas([..._tmp1['pack']], { bigDosageMinWidthMinutes, bigDosageTypeColorsLinear, bigDosageTypeColors, lfs })
      
      // rst.push(opt)
      rst.push(packedOpt) // 算法优化过的标签
      
      derror(`getBigDosageLabels, rst: `, rst)
      return rst      
    },
    getBasalSeries() { // 获取基础率的矩形表格效果图
      const { value, lfs, basalRateInfoMsg, lastUploadTime } = this
      derror(`getBasalSeries最后一次上传时间lastUploadTime: ${dayjs(lastUploadTime).format('YYYY-MM-DD HH:mm:ss')}`)
      const { threeChartData = {}, date, otherData = [] } = value
      const { insulinChart = {}} = threeChartData
      const { list: pumpRecord } = insulinChart
      const startOfDate = dayjs(date)
      const endOfDate = startOfDate.add(1, 'day') - 1
      const endOfDateT = +endOfDate
      const nowT = dayjs()
      const startOfDateT = +startOfDate
      const _basals_withoutAppendTwoPoints = _getPumpBasalFromRecords(pumpRecord)
      const _basals = _appendTwoPointsToBasals(date, _basals_withoutAppendTwoPoints, this.getDeadlineGaps(), this.yesterday, lastUploadTime)
      const _showLabelBasals = _getPumpBasalShouldShowLabelRecordsFromBasals(_basals)
      
      // /* *********临时基础率发生的时间点********* */
      // const _tempBasalTimes = (otherData.filter(_otherDataGetTempBasalFilter)).map(obj => +dayjs(obj.dateTimeStr))
      // /* *********End of 临时基础率发生的时间点********* */
      let basals = []
      // 改变数据结构，用来给echarts渲染
      basals = _basals.map(v => {
        const [v1, v2, ...rest] = v || []
        return [
          v1,
          _transferBasalData(v2),
          ...rest,
          `orin-${v2}`
        ]
      })
      // if (basals.length && nowT - endOfDateT < 0) { // date是今天，并且今天还没运行完(即没到23:59:59)
      //   const last = basals[basals.length - 1]
      //   const [t, v, isAppend, ...rest] = last
      //   if (isAppend) { // 认为最后一条是插入的数据，那么修改这条数据截止时间到nowT
      //     last[0] = +nowT
      //   }
      // }
      
      const arr = [] // 返回值
      
      // 生成基础率红线的series
      const gapsUnique = this.getDeadlineGaps(date)
      if (gapsUnique.length) {
        // 制作'画红线的series'
        const datas = []
        gapsUnique.forEach(gap => {
          datas.push(gap.map((t, i) => {
            const _beforeDate = t - startOfDateT < 0
            const _afterEnd = t - lastUploadTime >= 0
            const _dateIsAfterEnd = lastUploadTime - startOfDateT < 0
            const _nowIsInDate = dayjs().format('YYYY-MM-DD') === `${date}`
            
            if (i >= 1) {
              // gap end point
              if (_afterEnd) {
                if (_dateIsAfterEnd) {
                  error(`[逻辑黑洞]最后一次上传时间lastUploadTime: ${lastUploadTime}(${dayjs(lastUploadTime).format('YYYY-MM-DD HH:mm:ss')}), 是在今天${date}之前。这是有问题的。会导致逻辑有误`)
                  return [t, 0]
                } else {
                  if (_nowIsInDate) {
                    return [lastUploadTime, 0]                                      
                  } else {
                    return [t, 0]
                  }
                }
              } else {
                return [t, 0]
              }
            } else {
              // gap start point
              if (_beforeDate) {
                return [startOfDateT, 0]
              } else {
                return [t, 0]
              }
            }
          }))
        })
        // derror(`gaps转换出来的datas`, datas)
        derror(`gaps转换出来的datas`, datas.map(([s, e]) => [dayjs(s[0]).format('YYYY-MM-DD HH:mm:ss'), dayjs(e[0]).format('YYYY-MM-DD HH:mm:ss')]))
        
        datas.forEach(data => {
          arr.push({
            type: 'line',
            data,
            lineStyle: {
              width: 2,
              color: 'red'
            },
            symbol: 'none',
            smooth: true
          })
        })                
      }

      // window.dayjs = dayjs
      // debugger
      const rst = { // 矩形输注图;基础率
        z: -1,
        yAxisIndex: 1, // 右侧坐标轴
        name: 'area-line',
        type: 'line',
        step: 'end',
        silent: true,
        label: { // tbc:label得换成新的series去计算，否则无非做到放到矩形的正中间(好像改成step: middle就行了)
          silent: true,
          show: true,
          fontSize: labelSize,
          position: 'top',
          align: 'center',
          verticalAlign: 'bottom',
          distance: (8 / 12) * lfs,
          offset: [0, 0],
          formatter: (params = {}) => {
            return ''
            // const { data = [] } = params
            // return `${data[1]}${data[data.length - 1]}`
          },
          // formatter: (params = {}) => {
          //   const { data = [] } = params
          //   const value = data[1]
          //   const timePoint = data[0]
          //   // step1, 判断是否能显示label
          //   const shoudShowI = findObjIndexInArray(_showLabelBasals, data.slice(), (arrv, compareToMeArr) => {
          //     let same = false
          //     same = arrv && compareToMeArr && +arrv[0] === +compareToMeArr[0] // 时间点对上
          //     return same
          //   })
          //   const shouldShow = shoudShowI >= 0
          //   if (!shouldShow) {
          //     return ''
          //   }
          //   // step2, 判断这个显示label的基础率的前后_tempBuffer内没有临时基础率要显示,如果有的话，那么这个label不显示
          //   const _tempBuffer = (10 * 60 * 1000) // 10分钟范围内浮动
          //   const dontShowBecauseTempBasal = !_tempBasalTimes.every(v => {
          //     return Math.abs(timePoint - v) - _tempBuffer > 0 
          //   })
          //   if (dontShowBecauseTempBasal) {
          //     derror(`基础率label不显示，是因为附近有临时基础率;data: ${data}`)
          //     return ''
          //   }
          //   const l = data.length
          //   const last = data[l - 1]
          //   let orinV = ''
          //   if (/orin-(.+)/.test(last)) {
          //     orinV = RegExp.$1
          //   }
          //   if (value) { // 有值
          //     return orinV !== '' ? `${orinV}` : `${value}`
          //   } else { // 为0，不显示label
          //     return ''
          //   }
          // },
          color: this.basalC
        },
        lineStyle: {
          silent: true,
          show: true,
          width: 2,
          // color: '#00BAFF'
          color: this.basalBorderC
          // color: 'red'
          // color: '#7dd7fb'
        },
        areaStyle: {
          silent: true,
          emphasis: {
            disabled: true
          }, // 禁用停留高亮
          opacity: 0.2,
          color: this.basalC
        },
        symbolSize: 0,
        data: basals
      }
      console.error(`basalC`, this.basalC)
      
      arr.push(rst)
      return arr
      
      function _sameObj(v, compareToMeObj) {
        let same = false
        if (v && compareToMeObj) {
          same = v[0] && compareToMeObj[0] && +v[0] === +compareToMeObj[0]
        }
        return same
      }      
    },
    getImmediateBigDosageSeries() { // 立即大剂量(用户通过泵体的快捷键打的大剂量)
      const { value, lfs, quickPumpTagList = [], bigDosageMerged = [] } = this
      const { date } = value
      
      if (!quickPumpTagList.length || !bigDosageMerged.length) {
        return []
      }
      
      const dfmt = 'YYYY-MM-DD'
      const currentDateQuickPumps = quickPumpTagList.filter(obj => {
        return dayjs(date).format(dfmt) === dayjs(obj.dateTimeStr).format(dfmt)
      })
      
      const buffer = 60 // 秒为单位;这个buffer用来寻找根据 quickPumpTagList的时间戳，找到到对应的大剂量记录(前后浮动{buffer}时长)
      
      const _eventDatas = (currentDateQuickPumps.map((obj, i) => {
        const time = obj.dateTimeStr
        
        const respectBigDosageIndex = findObjIndexInArray(bigDosageMerged, { check_time: time }, function _sameTime(v, compareToMeObj) {
          let same = false
          
          const t1 = dayjs(v['check_time'])
          const t2 = dayjs(compareToMeObj['check_time'])
          
          if (Math.abs(t1 - t2) - buffer * 1000 <= 0) {
            same = true
          }
          
          return same
        })
        
        if (respectBigDosageIndex < 0) {
          error(`[接口数据返回有问题但逻辑不会崩]，字段quickPumpTagList的${i}下标的值，其dateTimeStr: ${time}。理论上应该在bigDosageMerged里头应该能找到一条记录记录，其check_time在${time}的前后1分钟. bigDosageMerged: `, bigDosageMerged)
          return undefined
        }
        
        const dosage = bigDosageMerged[respectBigDosageIndex]
        
        return [
          +dayjs(time),
          _transferBigDosageBarData(dosage.data),
          'needle'
        ]
      })).filter(v => !!v)
      
      const rst = {
        name: 'pumpImmediateBigDosages',
        type: 'line',
        showBackground: true,
        lineStyle: {
          width: 0
        },
        showSymbol: true,
        symbolOffset: ['-25%', '-40%'],
        symbol: (value, params) => {
          const eventType = value[2]
          const symbol = pumpGetSymbol(eventType)
          return symbol
        },
        symbolSize: 20,
        smooth: true,
        data: _eventDatas
      }
      return [rst]
    },
    pumpSeriesFromDataSource(what) {
      const { cmax, cmaxC, cmin, cminC, normalC, stripeBgC, stripeInnerBorderC, lfw, lfs, largerRatio, unit, ds, value, bigDosage, bigDosageMerged, bigDosageMinWidthMinutes } = this
      
      const series = [
        ...this.getBasalSeries(),
        ...this.getReservoirChangeSeries(), // 底版更换图标
        ...this.getPumpAlarmSeries(), // alarm图标
        ...this.getPumpClockSeries(), // clock图标
        ...this.getPumpUploadSeries(), // upload图标
        ...this.getBasalChangeSeries(), // 基础率设置切换图标
        ...this.getImmediateBigDosageSeries(), // 立即大剂量的图标
        ...this.getBigDosageSeries(), // 获取大剂量的矩形图
        ...this.getBigDosageVerticalSplitLineSeries(bigDosageMerged, true),
        ...this.getBigDosageLabels(), // 大剂量的label
      ]
      derror(`${what},series: `, series)
      
      return series
    },
    getSeriesFromDataSource(what) {
      const { cmax, cmaxC, cmin, cminC, normalC, stripeBgC, stripeInnerBorderC, lfw, lfs, largerRatio, unit, ds, value, isUnitMg } = this
      const { date } = value
      const nowT = dayjs()
      const startOfDay = nowT.startOf('day')
      
      const labelCom = {
        fontFamily: universalFontFamily,
        fontSize: (14 / 12 * lfs),
        padding: [2, 2],
        borderRadius: [2, 2, 2, 2]
      }
      
      const _seriesCom = {
        name: 'circle',
        type: 'line',
        lineStyle: {
          width: 1,
          color: 'black'
        },
        label: { // 数值、矩形底
          fontFamily: universalFontFamily,
          show: true,
          position: 'right',
          color: 'white',
          distance: (15 / 12) * lfs,
          offset: [-2, 0],
          formatter: 'functionPlaceHolder',
          rich: {
            placeholder: Object.assign({}, labelCom, {
              backgroundColor: 'transparent',
              opacity: 0
            }),
            normal: Object.assign({}, labelCom, {
              backgroundColor: normalC,
            }),
            max: Object.assign({}, labelCom, {
              backgroundColor: cmaxC
            }),
            min: Object.assign({}, labelCom, {
              backgroundColor: cminC
            })
          },
        },
        symbol: '',
        symbolSize: '',
        itemStyle: {
          color: 'functionPlaceHolder'
        },
        data: []
      }
      
      const series = []
      
      const { bloodGlucoseRecord = [], threeChartData = {}} = value
      const { cgmRecordList = [] } = threeChartData      
      const data = _sortCgmRecordListByTimeAsc(cgmRecordList)
      // 生成series
      const areaD = _dataConverter(data) // cgms值的线
      
      // derror(`data `, data)
      // derror(`after data `, afterD)
      
      let _gluAreaSeriesOpt
      if (areaD && areaD.length === 0) {
        // 压入一个占位数据，否则整个表格一片白
        derror(`压入一个占位数据，否则整个表格一片白`)
        const tmpv = cmax + 0.1
        // areaD.push([+(dayjs(date).add(3, 'hour')), cmax + 0.1, undefined, true]) // 数值必须大于cmax,这样子才能将2条分界线渲染出来(这可能是因为我yaxis没有设置max的原因导致的?)
        _gluAreaSeriesOpt = []
      } else {
        _gluAreaSeriesOpt = _createLineAreaWithDiffentColor(areaD, this) // 修改此处，此处是生成area范围(不同颜色)的配置。// 它是把一条线，根据值的大小，分成多个对象，每个对象对应一段颜色
      }
      
      const afterDataSorted = (bloodGlucoseRecord.slice()).sort((first, second) => dayjs(first.appTime) - dayjs(second.appTime))
      const afterD = _dataConverter2(afterDataSorted) // BG血糖(Pump BG 指血值，非cgms)
      // if (!(areaD && areaD.length === 0) && (afterD && afterD.length === 0)) {
      if (afterD && afterD.length === 0) {
        // 压入一个占位数据，否则整个表格一片白
        derror(`压入一个占位数据，否则整个表格一片白`)
        const tmpv = cmax + 0.1
        afterD.push([+(dayjs(date).add(3, 'hour')), _transferBGData(tmpv, isUnitMg), 0, true, tmpv]) // 数值必须大于cmax,这样子才能将2条分界线渲染出来(这可能是因为我yaxis没有设置max的原因导致的?)
      }
      
      // // startof mock,dev,test
      // const limits = [25, 20, 18, 15, 10, 5, 3.9, 3, 1, 0].map(v => (v * (isUnitMg ? 18 : 1)))
      // // eslint-disable-next-line
      // ;limits.forEach(v => {
      //   console.error(`_gluDatas推入v: ${v}`)
      //   afterD.push([+(dayjs(date).add(3, 'hour')), _transferBGData(v, isUnitMg), 0, false, v]) // test,dev,mock
      // })
      // // window.afterD = afterD
      // // endof mock,dev,test
      
      // _s1: BG血糖指血的配置
      const _s1 = Object.assign({}, qcopy(_seriesCom), {        
        data: afterD,
        name: `glucoseline`
      })
      
      _s1.lineStyle.width = 0 // 去掉连线
      _s1.label.formatter = _labelFormatter
      _s1.itemStyle.color = _itemStyleColor
      _s1.symbol = _symbolFormatter
      _s1.symbolSize = _symbolSizeFomatter
      
      series.push(..._gluAreaSeriesOpt)
      series.push(_s1)
      
      derror(`${what}, date: ${date},series: `, series)
      // derror(`series: ${JSON.stringify(series)}`)
      return series
      
      function _dataConverter(data) { // cgms
        const rst = data.map((d, i) => {
          return {
            time: +dayjs(d.appTime),
            value: _transferBGData(d.glucose, isUnitMg),
            truev: d.glucose
          }
        })
        // derror(`_dataConverter`, {
        //   data,
        //   rst
        // })
        return rst
      }
      function _dataConverter2(data) {
        // bloodGlucoseRecord:
        // {
        //   bloodGlucose: 144,          
        //   dataOrigin: 0, // 分别对应图标; 0: pump, 1: bg, 2: aidex, 3: cgms的bg; 在_symbolFormatter里头使用
        //   testTag: null,
        //   testTime: "2023-11-03 09:56:21+0800",
        //   appTime: "2023-11-03 09:56:21",
        //   zone: 4,          
        //   zone4h: 2
        // }
        return data.map((d, i) => {
          const v = _transferBGData(+d.bloodGlucose, isUnitMg)
          return [+dayjs(d.appTime), isUnitMg ? (v).toFixed(0) : (v).toFixed(1), d.dataOrigin, false, d.bloodGlucose] // [time, y, dataorigin, isPlaceholder, truev]
        })
      }
      
      function _labelFormatter(params = {}) {
        const { data = [] } = params
        // derror(`formatter, v: ${JSON.stringify(v)}, params: ${params}`)
        // const v = data[1]
        const truev = data[4]
        const isPlaceholder = !!data[3]
        if (isPlaceholder) {
          return `{placeholder|${truev}}`
        }
        let what = 'normal'
        if (isHighGlu(truev)) {
          what = 'max'
        } else if (isLowGlu(truev)) {
          what = 'min'
        }
        return `{${what}|${truev}}`
      }
      
      function _symbolFormatter(data = []) {
        // data: [time, y, dataorigin, isPlaceholder, truev]
        const _d = ''
        // derror(`_symbolFormatter, data:`, data)
        let what = data[2] // 是数字; 0: pump, 1: bg, 2: aidex, 3: cgms的bg
        // derror(`_symbolFormatter, what:`, what)
        if (what === undefined) {
          what = _d
        } else {
          const _map = ['emptyrect', 'emptydiamond', 'emptycircle', 'emptytriangle'] // pump, bg, aidex, cgm
          what = _map[what]
          if (what === undefined) {
            what = _d
          }
        }
        
        // derror(`_symbolFormatter, rst: ${what}`)
        return what
      }
      
      function _symbolSizeFomatter(data = []) {
        const isPlaceholder = !!data[3]
        if (isPlaceholder) {
          return 0
        } else {
          return 10
        }
      }
      
      function _itemStyleColor(params) {
        // derror(`_itemStyleColor`)
        const { data = [] } = params || {}
        const v = data[4] // [time, y, dataorigin, isPlaceholder, truev]
        
        let rst = normalC
        if (isHighGlu(v)) {
          rst = cmaxC
        } else if (isLowGlu(v)) {
          rst = cminC
        }
        return rst
      }
    },
    getGrid(what = 'top', orin = {}) {
      const { isFirst, lfs, isLast, isUnitMg } = this
      const rst = orin
      
      if (what === 'top') {
        rst.top = 0
        rst.bottom = 0
      }
      
      if (what === 'middle1') {
        rst.top = 0
        if (isUnitMg) {
          rst.top = 0
        }

        rst.top = lfs * 0.6 + 'px'
        rst.bottom = 0
      }
      if (what === 'middle2') { // co
        rst.top = 1 // 1是为了x轴显现
        rst.bottom = 1
      }
      
      if (what === 'bottom') {
        rst.bottom = lfs * 2
        rst.top = 0
      }
      
      return rst
    },
    getCommonXAxis(date) {
      const { lfs } = this
      const $start = date ? dayjs(date) : dayjs().startOf('day')
      const $end = $start.add(1, 'day').startOf('day')
      return [
        {
          boundaryGap: false,
          type: 'time',
          splitLine: {
            show: false
          },
          min: +$start,
          max: +$end,
          splitNumber: 24,
          // minInterval: 1,
          axisLine: {
            show: true,
            lineStyle: {
              color: _axisLineColor
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: _axisLabelColor,
            }
          },
          minorTick: {
            show: true
          },
          axisLabel: {
            show: true,
            showMaxLabel: true,
            color: _axisLabelColor,
            fontWeight: 800,
            fontSize: (18 / 12) * lfs,
            formatter: (v, i) => {
              // const _showIs = [1, 7, 13, 19, 24] // 0:00, 6:00, 12:00, 18:00
              // if (_showIs.includes(i)) {
              if ((i - 1) % 3 === 0) {
                const rst = dayjs(v).format('HH:mm')
                if (i > 1 && `${rst}` === '00:00') {
                  return '24:00'
                }
                return rst
              } else {
                return ''
              }
            }
          }
        }
      ]
    },
    getCommonGridOpt() {
      const { lfs, ds, w, isLongLanguage } = this
      const uiW = 1754
      const grid = {
        left: (52 / 12) * lfs,
        bottom: lfs * 2,
        // top: ((34 + 2) / 12) * lfs
        top: (((34 + 2) / 12) + 2) * lfs
      }
      grid.right = (52 / 12) * lfs
      if (isLongLanguage) {
        grid.left = grid.left * 1.9
      }
      
      const width24Hour = w - grid.left - grid.right
      const oneHourW = width24Hour / 24
      
      return Object.assign({}, grid, {
        oneHourW, width24Hour
      })
    },
    refreshTriggered() {
      derror(`refreshTriggered`)
      this.render(true)
    },
    render(isUpdate = false) {
      if (!isUpdate) {
        this.initChart()
      } else {
        this.updateChart()
      }
    },
    getOpt(what) {
      const { value, cmax, cmaxC, cmin, cminC, lfw, lfs, unit, bigDosageMerged, isUnitMg, unitRatio } = this
      const { date } = value      
      
      const grid = this.getGrid('middle1', this.getCommonGridOpt())
      
      const series = (this.getSeriesFromDataSource(what))
      const xAxis = this.getCommonXAxis(date)
      
      series.unshift({ // 高低血糖的境界的横线
        type: 'line',
        data: [],
        lineStyle: {
          width: 2
        },
        symbol: 'none',
        smooth: true,
        markLine: {
          symbol: 'none',
          data: [
            {
              silent: true, // 鼠标悬停事件  true没有，false有
              lineStyle: {
                type: 'dashed',
                color: cmaxC,
                width: 2
              },
              label: {
                show: true,
                position: 'end',
                distance: [lfs / 2, 0],
                color: cmaxC,
                formatter: (params) => {
                  return `${cmax}`
                },
                fontWeigt: lfw
              },
              yAxis: _transferBGData(cmax, isUnitMg) // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
            },
            {
              silent: true, // 鼠标悬停事件  true没有，false有
              lineStyle: {
                type: 'dashed',
                color: cminC,
                width: 2
              },
              label: {
                silent: true, // 鼠标悬停事件  true没有，false有
                show: true,
                position: 'end',
                distance: [lfs / 2, 0],
                color: cminC,
                formatter: (params) => {
                  return `${cmin}`
                },
                fontWeigt: lfw
              },
              yAxis: _transferBGData(cmin, isUnitMg)
            }
          ]
        }
      })
      
      series.push(...this.getBigDosageVerticalSplitLineSeries(bigDosageMerged, false)) // 插入大剂量的dash分割线
      
      const option = {
        animation: false,
        grid,
        xAxis,
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 30 * unitRatio,
            interval: 6 * unitRatio, // 在 ECharts 中，splitNumber 是一个建议值，表示希望将坐标轴分成的段数。实际的分割可能会根据数据范围和刻度的可读性进行调整。因此，即使设置了 splitNumber 为 5，ECharts 可能会选择不同的分割方式以确保刻度值是整洁和易读的。如果你希望强制使用特定的间隔，可以使用 interval 属性
            // splitNumber: 5,
            nameGap: 15,
            // name: unit,
            name: '',
            nameTextStyle: {
              ...labelCom,
              color: _axisLabelColor,
              fontWeight: 800,
              fontSize: (16 / 12) * lfs,
              padding: [0, 0, 0 - 0.4 * lfs, 0 - 0.8 * lfs]
            },
            minorTick: {
              show: false
            },
            splitLine: {
              show: true
            },
            splitArea: {
              show: false,
              areaStyle: {
                // 使用深浅的间隔色
                color: ['white', this.stripeBgC],
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: _axisLineColor
              },
            },
            axisLabel: {
              ...labelCom,
              margin: 0.8 * lfs,
              show: true,
              showMaxLabel: true,
              color: _axisLabelColor,
              fontWeight: 800,
              formatter: (...arr) => {
                const v = arr[0]
                const i = arr[1]
                // const rst = trimEndZero(`${(_transferBGData(v, isUnitMg)).toFixed((isUnitMg ? 0 : 1))}`)
                const rst = trimEndZero(`${(_transferYHeightToBGValue(v, isUnitMg)).toFixed((isUnitMg ? 0 : 1))}`)
                // const rst = v
                // const rst = trimEndZero(`${v}`) // test,dev
                derror(`axisLabel formatter`, {
                  arr,
                  rst
                })

                // if (['0', '20', '360'].includes(String(rst))) {
                //   return ''
                // }
                if (['0'].includes(String(rst))) {
                  return ''
                }
                
                return rst
              },
              fontSize: (18 / 12) * lfs
            },
            axisTick: {
              show: true, // 不显示刻度
            }
          },
          {
            type: 'value',
            min: 0,
            // max: 20,
            position: 'right',
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: _axisLineColor
              },
            },
            axisLabel: {
              show: false,
              showMaxLabel: false
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          },
          {
            type: 'value',
            min: 0,
            nameGap: 15,
            position: 'left',
            // name: `${dayjs(date).format('MM/DD')} ${readableWeek(dayjs(date))}`,
            name: '',
            nameTextStyle: {
              color: '#141414',
              fontSize: 20,
              fontWeight: 'bold',
              padding: [3, 4, lfs * 0.8, lfs * 10]
            },
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            splitArea: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              show: false,
              showMaxLabel: false,
              color: '#999',
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          }
        ],
        series
      }
      derror(`getOpt, option`, option)
      // derror(JSON.stringify(option))
      return option
    },
    getOptIconCo() {
      const { cmax, cmaxC, cmin, cminC, lfw, lfs, unit, value = {}, bigDosageMerged } = this
      const { date } = value
      
      const _coKey = 'carbsRecord'      
      const _coDatas = value[_coKey].map(v => {
        const rst = [
          +dayjs(v.dateTimeStr),
          this.$t('CO'),
          v.statusShort1
        ]
        return rst
      })      
      
      const grid = this.getGrid('middle2', this.getCommonGridOpt())
      const xAxis = this.getCommonXAxis(date)
      
      // x轴去掉label之类的，从而能当做正常的"底部border"来显示;底部border是通过grid.bottom为1或0，从而让x轴能渲染(当做border)或者在画布外渲染(从而无border)
      try {
        do {
          const x = xAxis[0]
          x.axisTick.show = false
          x.minorTick.show = false
          x.axisLabel.show = false
          x.axisLine.lineStyle.width = '1'
          // eslint-disable-next-line
        } while (false)
      } catch (error) {
        console.error('被捕获:' + error)
      }

      // 再增加一个顶部的border
      xAxis.push({
        type: 'time',
        position: 'top',
        splitLine: {
          show: false
        },
        axisLine: {
          onZero: false, // 默认是true,会导致position: top无效，一直显示在底部
          show: true,
          lineStyle: {
            color: _axisLineColor
            // color: 'red'
          },
        },
        axisLabel: {
          show: false,
          showMaxLabel: false
        },
        axisTick: {
          show: false,
          lineStyle: {
            color: 'red'
          }
        },
        minorTick: {
          show: false
        }
      })
      
      const option = {
        animation: false,
        grid,
        xAxis,
        yAxis: [
          {
            type: 'category',
            data: [
              this.$t('CO')
            ],
            boundaryGap: true,
            nameGap: 0,
            name: '0',
            nameTextStyle: {
              color: _axisLabelColor,
              fontWeight: 800,
              // fontSize: (18 / 12) * lfs,
              fontSize: 0,
              padding: [0, (29.4 / 12 * lfs), (0 - Math.round(17 / 12 * lfs / 2)), 0]
            },
            splitLine: {
              show: true
            },
            splitArea: {
              show: false,
              areaStyle: {
                // 使用深浅的间隔色
                // color: [this.stripeBgC, '#A5CBB8'],
                // color: [this.stripeBgC],
                color: [this.stripeBgC, '#E0FFF0'],
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: _axisLineColor
              },
            },
            axisLabel: {
              ...labelCom,
              margin: 0.8 * lfs,
              show: true,
              showMaxLabel: true,
              verticalAlign: 'center',
              color: _axisLabelColor,
              fontWeight: 800,
              fontSize: (16 / 12) * lfs,
              padding: [0, 10, 0, 0]
            },
            axisTick: {
              show: true, // 不显示刻度
            }
          },
          {
            type: 'value',
            min: 0,
            // max: 20,
            position: 'right',
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: _axisLineColor
              },
            },
            axisLabel: {
              show: false,
              showMaxLabel: false
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          }
        ],
        series: [
          {
            name: 'co-line',
            type: 'line',
            lineStyle: {
              show: false,
              width: 0
            },
            label: {
              show: true,
              position: 'right',
              color: 'black',
              offset: [-2, 0],
              formatter: (params) => {
                const { data } = params
                return data[2]
              },
              ...labelCom
            },
            symbolSize: 0,
            data: _coDatas
          },
          ...this.getBigDosageVerticalSplitLineSeries(bigDosageMerged, false)
        ]
      }
      
      derror(`getOptWithIconCo, option`, option)
      
      return option
    },
    getOptIconEvent() {
      const { cmax, cmaxC, cmin, cminC, lfw, lfs, unit, value = {}, bigDosageMerged, isUnitMg } = this
      const { date } = value
      
      // const _eventKeys = ['exerciseRecord', 'dietRecord', 'bloodGlucoseRecord', 'insulinRecord', 'medicationRecord']
      const _eventDatas = []
      const _eventKeys = ['exerciseRecord', 'dietRecord', 'insulinRecord', 'medicationRecord']
      const _eventKey2Type = ['excercise', 'Carbs', 'alert', 'medicine']
      const _eventKey2TimeKey = ['startTimeStr', 'mealTimeStr', 'injectionTimeStr', 'takenTimeStr']
      // const _eventKey2ValueKey = ['intensity', 'carbohydrate', 'insulinDosage', 'medicineDosage']
      _eventKeys.forEach((k, i) => {
        const arr = value[k] || []
        
        const narr = arr.forEach((v, j) => {
          const etype = _getEventType(k)
          const timekey = _eventKey2TimeKey[i]
          const dtime = v[timekey]
          
          if (undefined === dtime) {
            error(`获取event数据的时间失败, event type: ${etype}, timekey: ${timekey}, v: ${JSON.stringify(v)}`)
            return
          }
          
          _eventDatas.push([
            +dayjs(dtime),
            this.$t('Event'),
            etype
          ])
        })
      })
      
      function _getEventType(key) {
        if (!_eventKeys.includes(key)) {
          error(`未知的event type, key: ${key}`)
          return ''
        }
        
        const i = _eventKeys.indexOf(key)
        return _eventKey2Type[i]
      }
      
      // const labelCom = {
      //   fontSize: lfs - 2,
      //   padding: [1, 1, 1, 1],
      //   borderRadius: [2, 2, 2, 2]
      // }
      const labelCom = {
        fontFamily: universalFontFamily,
        color: 'red'
      }
      const grid = this.getGrid('top', this.getCommonGridOpt())
      const xAxis = this.getCommonXAxis(date)

      // 去掉axis tick
      try {
        xAxis[0]['axisTick']['show'] = false
        xAxis[0]['minorTick']['show'] = false
      } catch (error) {
        console.error('被捕获:' + error)
      }
      
      const option = {
        animation: false,
        grid,
        xAxis,
        yAxis: [
          {
            type: 'category',
            barCategoryGap: '10%',
            data: [
              this.$t('Event')
            ],
            boundaryGap: true,
            nameGap: (0 - lfs * (9 / 12)),
            // name: isUnitMg ? '360' : '20',
            name: isUnitMg ? '540' : '30',
            nameLocation: 'start',
            nameRotate: 0,
            nameTextStyle: {
              // color: _axisLabelColor,
              // backgroundColor: "rgba(255, 255, 255, 1)",
              // color: _axisLabelColor,
              fontWeight: 800,
              // fontSize: (18 / 12) * lfs,
              fontSize: 0, // 通过font size来控制是否显示
              height: lfs * 4,
              // padding: [0, (28.9 / 12 * lfs), (0 - Math.round(16 / 12 * lfs / 2)), 0] // 上方的半个0
              padding: isUnitMg ? [0, (50.3 / 12 * lfs), 0, 0] : [0, (40.3 / 12 * lfs), 0, 0] // 下方的20,需要配合nameRotate&nameLocation使用
            },
            splitLine: {
              show: true
            },
            splitArea: {
              show: true,
              areaStyle: {
                // 使用深浅的间隔色
                // color: [this.stripeBgC, '#A5CBB8'],
                // color: [this.stripeBgC],
                color: [this.stripeBgC],
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: _axisLineColor
              },
            },
            axisLabel: {
              margin: 0.8 * lfs,
              show: false,
              showMaxLabel: true,
              verticalAlign: 'center',
              color: _axisLabelColor,
              fontWeight: 800,
              fontSize: (16 / 12) * lfs,
            },
            axisTick: {
              show: true, // 不显示刻度
            }
          },
          {
            type: 'value',
            min: 0,
            // max: 20,
            position: 'right',
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: _axisLineColor
              },
            },
            axisLabel: {
              show: false,
              showMaxLabel: false
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          }
        ],
        series: [
          {
            name: 'event-line',
            // type: 'line',
            type: 'line',
            showBackground: true,
            lineStyle: {
              width: 0
            },
            showSymbol: true,
            symbol: (value, params) => {
              const eventType = value[2]
              const symbol = getSymbol(eventType)
              // if (eventType) {
              //   derror(`symbol, getSymbol result: ${symbol}, eventType: ${eventType}`)
              // }
              return symbol
            },
            symbolSize: 20,
            smooth: true,
            data: _eventDatas
          },
          ...this.getBigDosageVerticalSplitLineSeries(bigDosageMerged, false)
        ]
      }
      
      derror(`getOptWithIconEvent, option`, option)
      
      return option
    },
    getOptBar(what) {
      const { cmax, cmaxC, cmin, cminC, normalC, lfw, lfs, unit, isFirst, value } = this
      const { date } = value || {}
      
      const grid = this.getGrid('bottom', this.getCommonGridOpt())
      
      const series = (this.pumpSeriesFromDataSource(what))
      
      // const _eventDatas.push([
      //   +dayjs(dtime),
      //   '',
      //   etype
      // ])
      const _eventDatas = []
      
      series.unshift({
        name: 'event-line',
        type: 'line',
        showBackground: true,
        lineStyle: {
          width: 0
        },
        showSymbol: true,
        symbol: (value, params) => {
          const eventType = value[2]
          const symbol = pumpGetSymbol(eventType)
          return symbol
        },
        symbolSize: 20,
        smooth: true,
        data: _eventDatas
      })
      const xAxis = this.getCommonXAxis(date)

      try {
        const cfg = xAxis[0]
        const obj = cfg['axisLabel']
        const newO = Object.assign({}, labelCom, obj)
        cfg['axisLabel'] = newO
      } catch (error) {
        console.error('被捕获:' + error)
      }
      
      const option = {
        animation: false,
        grid,
        xAxis,
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 11,
            splitNumber: 11, // showMaxLabel设置成false，那么只会显示到10;因为maxLabel会显示不全，所以我们这边设置最大成11
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: isFirst ? {
                color: _axisLineColor
              } : {
                width: 2,
                color: 'black'
              }
            },
            axisLabel: {
              ...labelCom,
              show: isFirst,
              showMaxLabel: isFirst,
              color: _axisLabelColor,
              fontWeight: 800,
              fontSize: (16 / 12) * lfs,              
              formatter: (value, index) => { // 改变这里逻辑，要对应改变_transferBigDosageBarData
                // console.error(`坐标值, value: ${value}, index: ${index}`)
                const shouldShowVs = [0, 5, 10] // 这个是坐标值默认有的坐标值 _transferBigDosageBarData(10)或者_transferBigDosageBarData(11)的值为7； _transferBigDosageBarData(25)的值是10;
                const shouldShowTxts = [0, 5, `25U`] // 分别对应_transferBigDosageBarData(shouldShowTxts[i]) == shouldShowVs[i]
                const i = shouldShowVs.indexOf(+value)
                return i >= 0 ? shouldShowTxts[i] : ''
              }
            },
            axisTick: {
              show: false, // 不显示刻度
            }
          },
          {
            type: 'value',
            min: 0,
            max: 5.5,
            position: 'right',
            splitNumber: 11, // showMaxLabel设置成false，那么只会显示到10;因为maxLabel会显示不全，所以我们这边设置最大成11
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: isFirst ? {
                color: _axisLineColor
              } : {
                width: 2,
                color: 'black'
              }
            },
            axisLabel: {
              show: isFirst,
              showMaxLabel: isFirst,
              color: _axisLabelColor,
              fontWeight: 800,
              fontSize: (16 / 12) * lfs,
              formatter: (value, index) => { // 改变这里逻辑，要对应改变_transferBasalData
                // console.error(`坐标值, value: ${value}, index: ${index}`)
                
                const shouldShowVs = [0, 2.5, 5] // 这是坐标值已有的值
                const shouldShowTxts = [0, 2.5, `5U/h`] // _transferBigDosageBarData(shouldShowTxts[i]) == shouldShowVs[i]
                const i = shouldShowVs.indexOf(+value)
                return i >= 0 ? shouldShowTxts[i] : ''
              }
            },
            axisTick: {
              show: false, // 不显示刻度
              lineStyle: {
                color: _axisLabelColor,
              }
            }
          }
        ],
        series
      }
      derror(`bar option`, option)
      return option
    },
    renderZebraBars({ hasInited }) {
      const { h: _height, id, sortedBasalRateBaseSetting = [], basalC, yesterday, lastUploadTime } = this
      const height = _height * canvasRatio
      const _grid = this.getCommonGridOpt()
      const grid = {}
      // eslint-disable-next-line
      ;(Object.keys(_grid)).forEach(k => grid[k] = _grid[k] * canvasRatio)
      
      const { oneHourW, width24Hour } = grid
      const canvasid4 = `pumpDailyGraph_bar_${id}`
      const $canvas = document.getElementById(`${canvasid4}`).children[0].children[0]
      
      const ctx = $canvas.getContext('2d')
      
      if (!this._canvasMouseDisabled) {
        try {
          const $canvas = this._myCharts[3]
          $canvas.off('mouseover')
          $canvas.off('mouseout')
          this._canvasMouseDisabled = true
        } catch (error) {
          console.error('被捕获:' + error)
        }
      }
      
      /* ++++++++++计算出一天基础率++++++++++ */
      const { value, lfs, basalRateInfoMsg } = this
      const { threeChartData = {}, date, otherData = [] } = value
      const { insulinChart = {}} = threeChartData
      const { list: pumpRecord } = insulinChart
      
      const _basals_withoutAppendTwoPoints = _getPumpBasalFromRecords(pumpRecord)
      const _basals = _appendTwoPointsToBasals(date, _basals_withoutAppendTwoPoints, this.getDeadlineGaps(), this.yesterday, lastUploadTime)
      
      /* ++++++++++End of 计算出一天基础率++++++++++ */
      
      /* *********临时基础率********* */
      const _tempBasals = otherData.filter(_otherDataGetTempBasalFilter).filter(o => dayjs(o.dateTimeStr).format('YYYY-MM-DD') === `${date}`)

      const _tempBasalStopEvents = otherData.filter(_otherDataGetTempBasalStopFilter) // 用户强制终止临时基础率的输注
      derror(`otherData hasInited: ${hasInited}`, qcopy(otherData))
      derror(`_tempBasalStopEvents hasInited: ${hasInited}`, qcopy(_tempBasalStopEvents))
      /* *********End of 临时基础率********* */
      
      if (_basals.length) {
        // const $container = $(`#pumpDailyGraph_bar_${id} svg`)        
        
        const needDrawRst = []
        const asyncDrawCbs = [] // 异步画zebra图到canvas上
        const zebraRects = [] // 临时基础率矩形;其中y轴要从basal的y轴转化成 bigDosage的y轴 (关键是通过我写的_heightEquilToBigDosageV函数)
        const drawTitleRst = []
        const startOfDate = dayjs(date)
        const endOfDate = dayjs(date).add(1, 'day').subtract(1, 'second')
        
        const yesterdayDate = dayjs(date).subtract(1, 'day').format('YYYY-MM-DD')
        const yesterdayEndOfDate = dayjs(yesterdayDate).add(1, 'day').subtract(1, 'second')
        const yesterdayOtherData = (yesterday['otherData'] || []).filter(r => r?.appTime?.split(' ')[0] === yesterdayDate)
        
        /* ++++++++++根据前一天的临时基础率信息，判断是否要新增一条临时基础率到今天的开始时候（跨天）++++++++++ */
        do {
          if (yesterdayOtherData && yesterdayOtherData.length) {
            const otherData = yesterdayOtherData
            const _tempBasalsYes = (yesterdayOtherData.filter(_otherDataGetTempBasalFilter)).sort((first, second) => dayjs(first.dateTimeStr) - dayjs(second.dateTimeStr)) // 升序, dateTimeStr小的在数组前面
            const record = _tempBasalsYes[_tempBasalsYes.length - 1] // 最后一条，也就是yesterday最后一条临时基础率
            
            const isTempBasalVersion2 = _isTempBasalVersion2(record) // version2里头有临时基础率的持续时间信息
            if (isTempBasalVersion2) {
              const version2Duration = _getTempBasalDurationVersion2(record) // 单位: 小时
              let _tempDuration = version2Duration * 3600 // 单位秒              
              const start = +dayjs(record.dateTimeStr)
              const endTrue = dayjs(record.dateTimeStr).add(_tempDuration, 'second')
              const _durationToToday = endTrue.format('YYYY-MM-DD') !== `${yesterdayDate}`.trim()
              if (_durationToToday) {
                _tempDuration = 0
                // 昨天最后一个临时基础率持续到今天
                // 再判断一下昨天这个临时基础率之后是否已经被死线或者用户强制停止了
                // 还需要做额外的判断
                const deadGaps = this.getDeadlineGaps(yesterdayDate) // 一项的数据结构是: [starttimestamp, endtimestamp]
                const stopEvents = yesterdayOtherData.filter(_otherDataGetTempBasalStopFilter) // 用户强制终止临时基础率的输注
                const end = +yesterdayEndOfDate // 昨天的最后一刻(23:59:59)
                let dead // 死线
                let stop // 用户强制停止
                // 判断1, 这期间，是否有红线(死线)
                do {
                  const l = deadGaps.length
                  for (let i = 0; i < l; i++) {
                    const tmp = deadGaps[i]
                    const t = tmp[0]
                    const notInGap = (!(t - start >= 0 && t - end <= 0)) && (!(t - end >= 0 && t - start <= 0))
                    const inGap = !notInGap
                    if (inGap) {
                      dead = t
                      break
                    }
                  }
                  /* eslint-disable-next-line*/
                } while (false)
                
                // 判断2，这期间，是否有用户强制停止临时基础率的情况
                do {
                  const l = stopEvents.length
                  for (let i = 0; i < l; i++) {
                    const tmp = stopEvents[i]
                    const t = +dayjs(tmp['dateTimeStr'])
                    const notInGap = (!(t - start >= 0 && t - end <= 0)) && (!(t - end >= 0 && t - start <= 0))
                    const inGap = !notInGap
                    if (inGap) {
                      stop = t
                      break
                    }
                  }
                  /* eslint-disable-next-line*/
                } while (false)
                
                if (!stop && !dead) {
                  // 昨天最后的临时基础率，没有中途有停止(用户按了两下泵体，终止了临时基础率)、也没有死线
                  // 那么这个临时基础率会持续到今天
                  // 往今天的_tempBasals添加一天开始的临时基础率
                  const leftDuration = version2Duration * 3600 - ((yesterdayEndOfDate - start) / 1000) + 1
                  const leftDurationH = leftDuration / 3600 * 10
                  const fakeTempBasal = {
                    isFake: true,
                    dateTimeStr: startOfDate.format('YYYY-MM-DD HH:mm:ss'),
                    eventValue: leftDurationH, // 持续时间
                    eventType: record.eventType,
                    eventPort: record.eventPort,
                    statusByte0: record.statusByte0,
                    statusByte1: record.statusByte1,
                    statusShort0: record.statusShort0,
                    statusShort1: record.statusShort1,
                  }
                  derror(`昨天的临时基础率持续到今天, 插入一条假的临时基础率到今天的00:00, fakeTempBasal`, fakeTempBasal)
                  _tempBasals.unshift(fakeTempBasal)
                }
              }
            }
          }
          /* eslint-disable-next-line*/
        } while (false)
        /* ++++++++++End of 根据前一天的临时基础率信息，判断是否要新增一条临时基础率到今天的开始时候（跨天）++++++++++ */
        
        derror(`_basals_withoutAppendTwoPoints`, (qcopy(_basals_withoutAppendTwoPoints)).map(arr => {
          const [t, ...rest] = arr
          return [dayjs(t).format('YYYY-MM-DD HH:mm:ss'), ...rest]
        }))
        derror(`_basals`, (qcopy(_basals)).map(arr => {
          const [t, ...rest] = arr
          return [dayjs(t).format('YYYY-MM-DD HH:mm:ss'), ...rest]
        }))
        derror(`_tempBasals `, qcopy(_tempBasals))
        
        const l = _tempBasals.length
        if (!l) {
          console.warn(`${date}, 临时基础率没有记录，直接不画斑马矩形图`)
          return 
        }
        
        for (let i = 0; i < l; i++) {
          const record = _tempBasals[i]
          const isFake = record && record.isFake === true
          const settingIndex = record['statusByte1']
          const recordTime = record['dateTimeStr']
          const recordTimeDayjs = dayjs(recordTime)
          const isTempBasalVersion2 = _isTempBasalVersion2(record) // version2里头有临时基础率的持续时间信息
          let preBasalV

          if (dayjs(record.dateTimeStr).format('YYYY-MM-DD') !== `${date}`) {
            // 不是当天
            continue
          }
          
          if (!_isTempBasalVersion2Percent(record)) {
            // 老版本，或者新版本但不是%模式
            // step1, 获取预设值record发生时候(recordTime)的值
            const record = _tempBasals[i]
            const settingIndex = record['statusByte1']
            const recordTime = record['dateTimeStr']
            const baseI = findObjIndexInArray(sortedBasalRateBaseSetting, settingIndex, 'settingIndex')
            if (baseI < 0) {
              error(`[renderZebraBars]${date}, 临时基础率记录的预设基础率索引是: ${settingIndex},找不到相应的预设基础率,为了不让逻辑崩溃，直接continue到下一条`)
              continue
            }
            const base = sortedBasalRateBaseSetting[baseI]
            const { valueArray = '' } = base
            const preBasals = valueArray.split(',')
            const l2 = preBasals.length
            if (l2 < 48) {
              error(`[renderZebraBars]${date} 获取的预设基础率valueArray不足48个数值,有${l2}个数值, valueArray: ${valueArray}。为了不让逻辑崩溃，直接continue到下一条`)
              continue
            }
            if (l2 > 48) {
              derror(`[renderZebraBars]${date} 获取的预设基础率valueArray超过48个数值,有${l2}个数值, valueArray: ${valueArray}。`) // 提醒一下开发人员
            }
            const startOfDate = dayjs(date)
            const recordTimeDayjs = dayjs(recordTime)
            const diff = recordTimeDayjs.diff(startOfDate, 'hour', true)
            const recordPreBasalIndex = Math.floor(diff / 0.5) // 记录发生时候，对应预设值的时间段的index
            preBasalV = preBasals[recordPreBasalIndex] // 预设值
            if (preBasalV === undefined) {
              error(`[renderZebraBars]${date}, recordTime: ${recordTime}, diff in hours: ${recordPreBasalIndex}, recordPreBasalIndex: ${recordPreBasalIndex}, preBasals.length: ${l2};为了逻辑不崩，直接continue`)
              continue
            }
          }
          
          do {
            let _tempDuration = 0 // 单位秒
            
            if (!isTempBasalVersion2) {
              // 老版本的逻辑，version1
              // 老版本里头，是没有临时基础率的持续时间的
              // 所以老版本的逻辑只能说算出来的持续时间是90%准确的，无法做到100%
              // 老版本，不存在画多个矩形；新版本，由于有duration字段存在，同时临时基础率还能设置能百分比。
              // 那么新版本。在duration存在时段里头，用户又设置成了百分比基础率的模式，那么此时可能就会有高低不同的各个矩形(也即实际执行基础率在这个duration时段里有多个值)
              const startPointRangeInfo = _whatBasalsRange(_basals, +recordTimeDayjs)
              
              const _v = startPointRangeInfo.value
              const _vIndex = startPointRangeInfo.index
              
              const basal = _basals[_vIndex] // 非临时基础率
              // const time = dayjs(basal[0])
              const time = +recordTimeDayjs
              const v = basal[1]
              const vs = `${v}`.trim()
              if (vs === 'undefined') {
                // 服务端说，临时基础率发生的时候，那时候会有一个真实基础率，这个真实基础率就是临时基础率的值
                error(`[renderZebraBars]${date}, recordTime: ${recordTime},在step3计算这个临时基础率的持续时间时, 发现这个临时基础率的发生时的实际基础率是undefined，这是不允许的`)
                break
              }
              let protecter = 1
              let nextB
              let nextI = _vIndex + 1
              do {
                protecter++
                nextB = _basals[nextI]
                if (!nextB) {
                  break
                }
                const time2 = dayjs(nextB[0])
                _tempDuration = (time2 - time)                
                
                nextI++
              } while (`${nextB[1]}`.trim() === vs || protecter > 100)
              _tempDuration /= (1000) // 单位秒
              
              if (_tempDuration === 0) { // 不画了
                break
              }
              
              // step2, 获取recordTime对应的实际执行量
              if (_vIndex < 0) {
                error(`[renderZebraBars]${date}, recordTime: ${recordTime},都遍历完实际基础率的数组了，也没有找到${recordTime}对应的时间段执行的基础率`)
                continue // 跳过，下一个
              }
              
              needDrawRst.push({
                version: 1,
                count: 1, // 只要画一个zebra矩形
                v: _v,
                duration: _tempDuration,
                sp: +recordTimeDayjs,
                spStr: recordTimeDayjs.format('HH:mm'),
                ep: +recordTimeDayjs.add(_tempDuration, 'second'),
                epStr: recordTimeDayjs.add(_tempDuration, 'second').format('HH:mm')
              })
              drawTitleRst.push({
                version: 1,
                sp: +recordTimeDayjs,
                spStr: recordTimeDayjs.format('HH:mm'),
                _v,
                v: `${_v} ${_v - preBasalV <= 0 ? '-' : '+'} ${(+preBasalV !== 0) ? (Math.abs(_v - preBasalV) / preBasalV * 100).toFixed(1) : '0'}% ${_tempBasalDuration(_tempDuration, isFake)}`,
                duration: _tempDuration
              })
            } else {
              // version2, 记录里头有持续时间的信息
              const version2Duration = _getTempBasalDurationVersion2(record) // 单位: 小时
              _tempDuration = version2Duration * 3600 // 单位秒
              const isV2Percent = _isTempBasalVersion2Percent(record) // version2,判断是不是百分比模式,如果不是的话，那么就值
              const v2Value = !isV2Percent ? (trimEndZero((record.statusShort0 / 160).toFixed(3))) : 0
              const start = +dayjs(record.dateTimeStr)
              const _end = +(dayjs(record.dateTimeStr).add(_tempDuration, 'second'))
              let end = +(dayjs(record.dateTimeStr).add(_tempDuration, 'second'))
              if (_end - lastUploadTime >= 0) {
                // 持续时间超过 lastUploadTime
                // 那么要将结束时间改成 lastUploadTime
                if (start - lastUploadTime >= 0) {
                  error(`[逻辑黑洞]临时基础率是version2的数据，带有持续时间。然后这个临时基础率的开始时间，竟然在最后一次上传数据的时刻之后? lastUploadTime: ${dayjs(lastUploadTime).format('YYYY-MM-DD HH:mm')}    直接不画这个临时基础率了`)
                  break
                } else {
                  end = lastUploadTime
                  _tempDuration = Math.floor((end - start) / 1000)
                }
              }
              // 还需要做额外的判断
              const deadGaps = this.getDeadlineGaps() // 一项的数据结构是: [starttimestamp, endtimestamp]
              const stopEvents = _tempBasalStopEvents // 每一项的数据结构是接口返回的otherData的其中一项的数据结构
              let dead // 死线
              let stop // 用户强制停止
              // 判断1, 这期间，是否有红线(死线)
              do {
                const l = deadGaps.length
                for (let i = 0; i < l; i++) {
                  const tmp = deadGaps[i]
                  const t = tmp[0]
                  const notInGap = (!(t - start >= 0 && t - end <= 0)) && (!(t - end >= 0 && t - start <= 0))
                  const inGap = !notInGap
                  if (inGap) {
                    dead = t
                    break
                  }
                }
                /* eslint-disable-next-line*/
              } while (false)
              
              // 判断2，这期间，是否有用户强制停止临时基础率的情况
              do {
                const l = stopEvents.length
                for (let i = 0; i < l; i++) {
                  const tmp = stopEvents[i]
                  const t = +dayjs(tmp['dateTimeStr'])
                  const notInGap = (!(t - start >= 0 && t - end <= 0)) && (!(t - end >= 0 && t - start <= 0))
                  const inGap = !notInGap
                  if (inGap) {
                    stop = t
                    break
                  }
                }
                /* eslint-disable-next-line*/
              } while (false)

              if (stop || dead) {
                // 中途有停止(用户按了两下泵体，终止了临时基础率)或者有死线
                const ends = ((([stop, dead]).filter(v => !!v)).sort((a, b) => a - b)) // 降序，最小的在最前面
                const breakPoint = ends[0]
                
                if (breakPoint) {
                  const duration = (breakPoint - start) / (1 * 1000) // 秒
                  
                  if (duration >= 0) {
                    // 更新_tempDuration
                    _tempDuration = duration
                  } else {
                    error(`[数据黑洞，逻辑黑洞]返回的临时基础率是version2,有持续时间信息;同时期间有死线或者停止事件，但是死线和停止事件的start时间点, 不在这个record的时间范围内，逻辑有问题。stop: ${stop}, dead: ${dead}; record是${JSON.stringify(record)}`)
                  } 
                }
              }
              
              // 实际的持续时间确定下来后,要判断一下这段时间里头有几个实际执行的值
              if (_tempDuration) { // 临时基础率的持续时间
                const startPointRangeInfo = _whatBasalsRange(_basals, +recordTimeDayjs)
                
                let _v = startPointRangeInfo.value
                if (!isV2Percent) {
                  // version2,是值的模式;
                  _v = v2Value
                }
                const _vIndex = startPointRangeInfo.index
                
                // 计算在这个持续时段里头，有几个实际执行的基础率值
                const _tempBasalTrueEndPoint = recordTimeDayjs.add(_tempDuration, 'second')
                const _isNextDay = _tempBasalTrueEndPoint.format('YYYY-MM-DD') !== `${date}`.trim()
                if (_isNextDay) { // 到第二天去了
                  _tempDuration = Math.floor((endOfDate - recordTimeDayjs - 1) / 1000) // 23:59:59再小一微秒
                }
                
                const _tempBasalEndPoint = recordTimeDayjs.add(_tempDuration, 'second')
                const endPointRangeInfo = _whatBasalsRange(_basals, +_tempBasalEndPoint)
                /* eslint-disable-next-line*/
                // const basalsForDebugger = _basals.map(v => {
                //   const [t, v0, ...rest] = v
                //   const rst = [dayjs(t).format('DD HH:mm'), v0, ...rest]
                //   return rst
                // })
                
                const _evIndex = endPointRangeInfo['index']
                
                if (_vIndex < 0) {
                  error(`[数据黑洞，逻辑黑洞]找不到_vIndex, ${date}返回的临时基础率是version2,有持续时间信息;开始时间是：${recordTime}, 这个时间段却找不到实际的执行率`)
                  break
                }
                if (_evIndex < 0) {
                  error(`[有可能是跨天了。数据黑洞，逻辑黑洞]找不到_evIndex, ${date}返回的临时基础率是version2,有持续时间信息;开始时间是：${recordTime}, 获取到的version2的持续时间是： ${version2Duration}(/小时), 排除掉死线、人工停止等，实际的持续时间是:${_tempDuration} second, 这个时间段却找不到实际的执行率, record:`, record)
                  break
                }
                
                const gap = _evIndex - _vIndex
                
                if (gap < 0) {
                  error(`[数据黑洞，逻辑黑洞]${date}返回的临时基础率是version2有持续时间信息，_evIndex却小于_vIndex，这是不对的.开始时间是：${recordTime}, _vIndex: ${_vIndex},获取到的version2的持续时间是： ${version2Duration}(/小时), 排除掉死线、人工停止等，实际的持续时间是:${_tempDuration} second, _evIndex: ${_evIndex}`)
                  break                  
                }                
                
                let maxBasalVInRange = -1
                
                for (let i = _vIndex; i <= _evIndex; i++) {
                  // if (_vIndex >= 10) {
                  //   debugger
                  // }
                  const trueBasal = _basals[i]
                  const v = !isV2Percent ? v2Value : trueBasal[1]
                  const tv = trueBasal[1]
                  const t = trueBasal[0]
                  const max = Math.max(+maxBasalVInRange, +tv)
                  
                  if (i - _evIndex >= 0) { // 最后一个,终点
                    // max计算应该不包含_evIndex
                    // maxBasalVInRange = (Number.isNaN(max)) ? maxBasalVInRange : max
                    
                    const endPoint = +_tempBasalEndPoint
                    let rst
                    
                    if (gap === 0) {
                      // 持续时间是实际运行的子集(_vIndex === _evIndex)
                      const sp = +recordTimeDayjs
                      rst = {
                        version: 2,
                        count: 1,
                        v: v,
                        sv: v,
                        sp,
                        spStr: dayjs(sp).format('HH:mm'),
                        duration: dayjs(endPoint).diff(dayjs(sp), 'second', true),
                        ep: endPoint,
                        epStr: dayjs(endPoint).format('HH:mm')
                      }
                    } else {
                      rst = {
                        version: 2,
                        count: 1,
                        v: v,
                        sv: v,
                        sp: t,
                        spStr: dayjs(t).format('HH:mm'),
                        duration: dayjs(endPoint).diff(dayjs(t), 'second', true),
                        ep: endPoint,
                        epStr: dayjs(endPoint).format('HH:mm')
                      } 
                    }

                    Object.assign(rst, {
                      isV2Percent  
                    })
                    if (!isV2Percent) {
                      Object.assign(rst, {
                        v2Value
                      })
                    }
                    needDrawRst.push(rst)
                  } else { // 不是最后一个点
                    maxBasalVInRange = (Number.isNaN(max)) ? maxBasalVInRange : max
                    
                    const nextI = i + 1
                    const next = _basals[nextI]
                    const endPoint = next[0]
                    const rst = {
                      version: 2,
                      count: 1,
                      v,
                      sv: v,
                      sp: t,
                      spStr: dayjs(t).format('HH:mm'),
                      duration: dayjs(endPoint).diff(dayjs(t), 'second', true),
                      ep: endPoint,
                      epStr: dayjs(endPoint).format('HH:mm'),
                      ev: next[1],
                      ei: nextI
                    }
                    if (i === _vIndex) { // 第一个点(即临时基础率事件的发生点)
                      rst.duration = dayjs(endPoint).diff(recordTimeDayjs, 'second', true)
                      rst.sp = +recordTimeDayjs
                      rst.spStr = recordTimeDayjs.format('HH:mm')
                    }

                    Object.assign(rst, {
                      isV2Percent  
                    })
                    if (!isV2Percent) {
                      Object.assign(rst, {
                        v2Value
                      })
                    }
                    needDrawRst.push(rst)
                  }
                }
                
                if (isV2Percent) {
                  // 临时基础率，是百分比
                  const percent = _getTempBasalVersion2Percent(record)
                  
                  // if (percent && percent >= 0) {
                  const rst = {
                    version: 2,
                    isV2Percent,
                    sp: +recordTimeDayjs,
                    spStr: recordTimeDayjs.format('HH:mm'),
                    v: `${(+percent).toFixed(0)}% ${_tempBasalDuration(_tempDuration, _isNextDay || isFake)}`,
                    duration: _tempDuration
                  }

                  if (maxBasalVInRange >= 0) {
                    rst._v = maxBasalVInRange
                  }
                  drawTitleRst.push(rst)
                  // } else {
                  //   error(`[数据错误]临时基础率是version2，同时又是百分比模式，但是取出来的百分比不合法.record: `, record)
                  // }
                } else {
                  // 临时基础率，是值
                  drawTitleRst.push({
                    version: 2,
                    isV2Percent,
                    v2Value,
                    sp: +recordTimeDayjs,
                    spStr: recordTimeDayjs.format('HH:mm'),
                    _v,
                    v: `${_v} ${_v - preBasalV <= 0 ? '-' : '+'} ${(+preBasalV !== 0) ? (Math.abs(_v - preBasalV) / preBasalV * 100).toFixed(1) : '0'}% ${_tempBasalDuration(_tempDuration, _isNextDay || isFake)}`,
                    duration: _tempDuration
                  })
                }
              }
            }
            
            /* eslint-disable-next-line*/
          } while (false)                   
          
          derror(`needDrawRst,`, needDrawRst)
          this._needDrawRst = needDrawRst          
        }
        
        // step4, 开始画图
        const paddingBottom = (37.8 / 12) * lfs * canvasRatio - 1
        const tenthHeight = (1 / 11) * (height * 0.9 - 0.9 * lfs) // 大剂量值为1对应的高度；如果echarts的y纵坐标变化了， 那么这个tenthHeight要跟着变;
        
        for (let i = 0; i < needDrawRst.length; i++) {
          derror(`before render zebra`)
          const uiInfo = needDrawRst[i]
          if (!uiInfo) {
            error(`[逻辑黑洞]当前用来画斑马图zebra的uiInfo是空的, needDrawRst`, needDrawRst)
            continue
          }
          
          // const isVersion1 = uiInfo && +uiInfo.version === 1
          const _tempDuration = uiInfo.duration // 单位秒
          const _v = uiInfo.v
          const w = oneHourW * _tempDuration / 3600 // 单位小时
          const recordTimeDayjs = dayjs(uiInfo.sp)
          const diff = recordTimeDayjs.diff(startOfDate, 'hour', true)
          // const h = tenthHeight * _transferBasalData(_v) * 2
          const h = _transferBigDosageBarData(_heightEquilToBigDosageV(_transferBasalData(_v)), {
            _trueV: _v,
            _basalHeight: _transferBasalData(_v)
          }) // 从基础率(basal)的y轴转化成 大剂量的y轴值
          const xoffset = diff / 24 * width24Hour + grid.left
          
          // const _tempTitle = `${_v} ${_v - preBasalV <= 0 ? '-' : '+'} ${(+preBasalV !== 0) ? (Math.abs(_v - preBasalV) / preBasalV * 100).toFixed(1) : '0'}% ${_tempBasalDuration(_tempDuration)}`
          // const titleX = xoffset + w / 2 - 2.5 * lfs
          // const titleY = height - paddingBottom - 0.8 * lfs
          const titleX = w / 2
          const titleY = -0.8 * lfs * canvasRatio
          
          const translate = `translate(${xoffset}, ${height - h * canvasRatio - paddingBottom})`
          
          derror(`before render zebra22, `, $canvas)
          
          derror(`before render zebra33`)
          
          const _robj = { // 要是直角坐标系
            _v,
            basalH: _transferBasalData(_v),
            x: xoffset,
            // y: height - h - paddingBottom,
            y: 0,
            width: (((w + (0.0096 * oneHourW)) / oneHourW) * 3600 * 1000), // 加个buffer,免得空出来从而出现白线
            height: h
          }
          zebraRects.push(_robj)
          asyncDrawCbs.push(() => {
            this.renderZebraRect(ctx, { rect: _robj, h, height, paddingBottom, tenthHeight, oneHourW })
          })
        }
        
        // 画title
        const $s = dayjs(date)
        const stime = +($s.startOf('day'))
        const etime = +($s.endOf('day'))        
        const packedBigDosageRect = _cache['pack'] || []
        const unpackBigDosageRect = _cache['unpack'] || []
        const bigDosageLabelRects = [...unpackBigDosageRect, ...packedBigDosageRect]
        // window.needDrawRst = needDrawRst // test,dev,mock
        // window.drawTitleRst = drawTitleRst // test,dev,mock
        const zebraTitleRects = drawTitleRst.map(title => {
          const recordTimeDayjs = dayjs(title.sp)
          const _tempTitle = title.v
          const titleW = Rect.getTempBasalTitleWidth(_tempTitle)
          const trueV = title._v
          const h = _transferBasalData(trueV)
          const buffer = 0.2
          const y0H = _transferBigDosageBarData(_heightEquilToBigDosageV(h)) + buffer // trueV的基础率对应的高度，相当于y0H的大剂量的y轴对应的高度;buffer相当于echarts的distance
          // const barW = title.duration * 1000 * canvasRatio
          const barW = title.duration * 1000
          const xstart = Math.floor(title.sp + barW / 2 - titleW / 2) // title文案的align一定是left
          return new Rect([
            { xAxis: xstart, yAxis: 0 },
            { ...title, xAxis: (xstart + barW), yAxis: y0H, tv: trueV, td: true, tvTxt: _tempTitle }, // point2的tv和td影响Rect.findAvailablePosition的逻辑; point2的xAxis用来算barWidth
          ], { stime, etime, isLabel: true, isBasal: true, canvasRatio })
        })
        const avoidTheseRects = [...bigDosageLabelRects, ...zebraRects]
        const _sortedTitleRects = zebraTitleRects.sort((rA, rB) => {
          const oA = Rect.findMaxOverlapRectangleAndArea(rA, avoidTheseRects)
          const oB = Rect.findMaxOverlapRectangleAndArea(rB, avoidTheseRects)
          return oB.area - oA.area // Rect.findMaxOverlapRectangle越大的越前面,即: 能绘画空间最小的越前面
        })
        
        // title的标签，进行位移算法的处理,尽量不使得标签重叠
        const _tmp1 = Rect.packRectangles(_sortedTitleRects, (etime - stime), 10, avoidTheseRects)
        _cache['zebraPack'] = _tmp1['pack']
        _cache['zebraUnpack'] = _tmp1['unpack']
        const zebraLabelRectsNeedDraw = [..._tmp1['unpack'], ..._tmp1['pack']]
        const _tmp2 = _drawRectsToCanvas(zebraLabelRectsNeedDraw, { isBasal: true })
        
        // 画到canvas上
        const _buffer = tenthHeight * 0.4
        asyncDrawCbs.push(() => {
          const { opt = {}} = _tmp2
          const { data = [], markLine = {}} = opt
          const markLines = markLine.data || []
          // 先画辅助线
          markLines.forEach(arr => {
            const start = arr[0]
            const s = start.coord
            const sx = s[0]
            const sy = s[1]
            
            const end = arr[1]
            const e = end.coord
            const ex = e[0]
            const ey = e[1]
            
            // start point
            const ratio = 1
            const $s = dayjs(sx)
            const sdiff = $s.diff(startOfDate, 'hour', true)
            const sxoffset = sdiff / 24 * grid.width24Hour + grid.left
            const syH = height - (sy * tenthHeight * ratio + paddingBottom + _buffer)
            
            // end point
            const $e = dayjs(ex)
            const ediff = $s.diff(startOfDate, 'hour', true)
            const exoffset = ediff / 24 * grid.width24Hour + grid.left
            const eyH = height - (ey * tenthHeight * ratio + paddingBottom + _buffer)
            
            ctx.setLineDash([~~(lfs * 0.4), ~~(lfs * 0.2)])
            // ctx.strokeStyle = '#333'
            ctx.strokeStyle = 'rgba(51, 51, 51, 0.4)' // #333: rgb(51, 51, 51)
            ctx.beginPath()
            ctx.moveTo(sxoffset, syH)
            ctx.lineTo(exoffset, eyH)
            // ctx.globalCompositeOperation = 'destination-over' // 画到原有图(echarts画的)下面
            ctx.globalCompositeOperation = 'source-over' // 画到原有图(echarts画的)之上
            ctx.stroke()
          })
          
          // 再画label rects
          ctx.setLineDash([]) // 切回实线
          data.forEach(arr => {
            const [x, y, tv, td, ds, xend, type, groupId, extendId, i, barStartX, barWidth, barHeight] = arr
            const r = zebraLabelRectsNeedDraw[i]
            const titleTxt = r.tvTxt || '-'
            const titleWidth = ((xend - x) / (1000)) / 3600 * (grid.width24Hour / 24)
            
            ctx.font = `200 ${labelSize * canvasRatio}px sans-serif`
            ctx.fontFamily = universalFontFamily
            ctx.strokeStyle = basalC
            ctx.textAlign = 'left' // 这个修改，有影响title标签的检测碰撞逻辑
            // ctx.globalCompositeOperation = 'destination-over' // 画到原有图(echarts画的)下面
            ctx.globalCompositeOperation = 'source-over' // 画到原有图(echarts画的)之上
            // ctx.textBaseline = ''
            
            const $x = dayjs(x)
            const $xend = dayjs(xend)
            const duration = $xend.diff($x, 'hour', true) * (grid.width24Hour / 24)
            const diff = $x.diff(startOfDate, 'hour', true)
            const xoffset = diff / 24 * grid.width24Hour + grid.left
            const ratio = 1
            const yH = height - (y * tenthHeight * ratio + paddingBottom + labelSize * canvasRatio * 1) // canvas的坐标系是窗口坐标系，和直角坐标系不一样
            ctx.strokeText(titleTxt, xoffset, yH)
            // ctx.strokeRect(xoffset, yH - labelSize, titleWidth, labelSize) // 画出title文本的边框
          })
        })
        
        this._zebraDrawed = true
        asyncDrawCbs.forEach(cb => {
          cb() 
        })
        // if (this._zebraDrawed) {
        //   derror(`鼠标停留变成手手，马上重绘斑马...`)
        //   asyncDrawCbs.forEach(cb => {
        //     cb() 
        //   })
        // } else {
        //   // async do draw(异步画canvas图)        
        //   setTimeout(() => {
        //     this._zebraDrawed = true
        //     asyncDrawCbs.forEach(cb => cb())
        //   }, 1000 * 1.5) 
        // }
      } else { // 
        derror(`没有基础率，不画`)
      }
    },
    renderZebraRect(context, extra = {}) {
      const { rect = {}, oneHourW, height, paddingBottom, tenthHeight } = extra // paddingBottom是x坐标轴和canvas边界的距离
      const { x = 0, y = 0, width = 0 } = rect // 入参是直角坐标系，最后画到cavas上要转换成 视窗坐标系
      const h = rect.height // 从基础率(basal)的y轴转化成 大剂量的y轴值
      if (!width || !h) {
        derror(`renderZebraRect的长宽有一个为空，那么不画斑马图了`, extra)
        return false
      } else {
        try {
          const tile = this.createTile()
          derror(`renderZebraRect, rect. typeof context: ${typeof context};typeof context.createPattern: ${typeof context.createPattern}`, {
            extra,
            tile
          })
          context.globalCompositeOperation = 'destination-over' // 画到原有图(echarts画的)下面
          context.fillStyle = context.createPattern(tile, 'repeat')
          // context.fillStyle = 'red'
          
          const windowX = x
          const windowHeight = tenthHeight * h
          const windowY = height - windowHeight - paddingBottom
          const windowWidth = (width / (3600 * 1000)) * oneHourW
          context.fillRect(windowX, windowY, windowWidth, windowHeight)
        } catch (error) {
          console.error('renderZebraRect被捕获:' + error)
        }
      }
    },
    createTile: function _createTile(extra = {}) {
      // const { w = 30, c1 = '#9AE0FB', c2 = '#7DD7FB' } = extra
      const { w = 30 } = extra
      const opa = 1
      const c1 = `rgba(154, 224, 251, ${opa})`
      const c2 = `rgba(125, 215, 251, ${opa})`
      if (_createTile._cache) {
        return _createTile._cache
      }
      
      const tile = document.createElement('canvas')
      tile.width = tile.height = w
      const tileCtx = tile.getContext('2d')
      const gradient = tileCtx.createLinearGradient(0, 0, tile.width, tile.height)
      
      gradient.addColorStop(0, c1)
      gradient.addColorStop(0.25, c1)
      gradient.addColorStop(0.25, c2)
      gradient.addColorStop(0.5, c2)
      gradient.addColorStop(0.5, c1)
      gradient.addColorStop(0.75, c1)
      gradient.addColorStop(0.75, c2)
      gradient.addColorStop(1, c2)
      tileCtx.fillStyle = gradient
      tileCtx.fillRect(0, 0, w, w)
      
      _createTile._cache = tile
      
      return tile
    },
    initChart() {
      const { id } = this
      const canvasid = `pumpDailyGraph_${id}`
      const canvasid2 = `pumpDailyGraph_co_${id}` // co 
      // const canvasid3 = `pumpDailyGraph_event_${id}` // event
      const canvasid4 = `pumpDailyGraph_bar_${id}`
      try {
        const date = this.value.date
        // if (date === '2023-11-28') {
        //   debugger
        // }
        const myChart = this.$echarts.init(document.getElementById(`${canvasid}`), null, { renderer: 'svg' })
        const opt = this.getOpt('initChart')
        
        myChart.setOption(opt)
        
        const myChart2 = this.$echarts.init(document.getElementById(`${canvasid2}`), null, { renderer: 'svg' })
        const opt2 = this.getOptIconCo('initChart')
        
        myChart2.setOption(opt2)
        
        // const myChart3 = this.$echarts.init(document.getElementById(`${canvasid3}`), null, { renderer: 'svg' })
        // const opt3 = this.getOptIconEvent('initChart')
        
        // myChart3.setOption(opt3)

        // 使用canvas渲染会有点糊，所以需要设置ratio: canvasRatio;这个ratio会影响斑马图的绘制
        const myChart4 = this.$echarts.init(document.getElementById(`${canvasid4}`), null, { renderer: 'canvas', devicePixelRatio: canvasRatio })
        // const myChart4 = this.$echarts.init(document.getElementById(`${canvasid4}`), null, { renderer: 'svg' })
        const opt4 = this.getOptBar('initChart')
        myChart4.on('finished', () => {
          try {
            // if (date === '2023-11-28') {
            //   debugger
            // }
            this.renderZebraBars({ hasInited: false })
          } catch (error) {
            console.error('finished 被捕获:' + error)
          }
          derror(`myChart4 finished, date: ${date}`)
        })
        myChart4.setOption(opt4)       
        
        // this._myCharts = [myChart, myChart2, myChart3, myChart4]
        this._myCharts = [myChart, myChart2, null, myChart4]
      } catch (error) {
        console.error('被捕获:' + error)
      }
    },
    updateChart() {
      const newOpt = this.getOpt('updateChart')
      const newOptIcon = this.getOptIconCo('updateChart')
      // const newOptIcon2 = this.getOptIconEvent('updateChart')
      const newOptBar = this.getOptBar('updateChart')
      
      this.$nextTick(() => {
        try {
          const myChart = this._myCharts[0]
          if (myChart) {
            myChart.setOption(newOpt)            
          }
          
          const myChartIcon = this._myCharts[1] // co
          if (myChartIcon) {
            myChartIcon.setOption(newOptIcon)
          }
          
          // const myChartIcon2 = this._myCharts[3] // event
          // if (myChartIcon2) {
          //   myChartIcon2.setOption(newOptIcon2)
          // }
          
          const myChartBar = this._myCharts[3]
          if (myChartBar) {
            myChartBar.setOption(newOptBar)
          }
        } catch (error) {
          console.error('被捕获:' + error)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
